const versoes = [
  {
    versao: '2.38.68',
    data: '30/07/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novas opções de "Motivo de saída" do PAD (Inativação de Paciente).'
      },
      {
        tipo: 'add',
        texto: 'Adicionado botão de passagem de plantão no card do profissional.'
      },
      {
        tipo: 'edit',
        texto: 'Simplificado captcha da página de envio de formulários.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da permissão de exibição do botão (Preços) em pacientes.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da assinatura em modelos de documento.'
      }
    ]
  },
  {
    versao: '2.38.66',
    data: '28/07/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção do filtro de especialidades em visitas.'
      }
    ]
  },
  {
    versao: '2.38.65',
    data: '25/07/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Correção no cálculo de quantidade nas vendas.'
      }
    ]
  },
  {
    versao: '2.38.64',
    data: '25/07/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada a opção de calcular a quantidade por período nas vendas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionados modelos e área de passagem de plantão para visitas.'
      }
    ]
  },
  {
    versao: '2.38.63',
    data: '24/07/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada exportação Excel dos lotes de Faturamento XML com total de atendimentos e serviços prestados.'
      },
      {
        tipo: 'add',
        texto: 'Implementado controle de clonagem de prescrições baseado em especialidade do profissional.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da assinatura Autentique.'
      }
    ]
  },
  {
    versao: '2.38.62',
    data: '22/07/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de bloqueio para limite de quantidade máxima de notas de evolução permitidas no site.'
      },
      {
        tipo: 'bug',
        texto: 'Correção do profissional exibido no cabeçalho do relatório de visistas.'
      }
    ]
  },
  {
    versao: '2.38.61',
    data: '18/07/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção da assinatura em vendas, orçamentos e visitas.'
      }
    ]
  },
  {
    versao: '2.38.60',
    data: '15/07/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Ajuste na formatação do desconto e acréscimo de venda, compra e orçamento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de erro ao gerar relatórios de agendamentos.'
      }
    ]
  },
  {
    versao: '2.38.59',
    data: '14/07/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção ao cancelar pagamentos e recebimentos.'
      }
    ]
  },
  {
    versao: '2.38.58',
    data: '11/07/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada opção de limitar quantidade de evoluções a serem criadas por visita.'
      }
    ]
  },
  {
    versao: '2.38.57',
    data: '10/07/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ajuste do relatório de pagamento venda.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido as informações do responsável na impressão do PDF.'
      }
    ]
  },
  {
    versao: '2.38.56',
    data: '08/07/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria do posicionamento da assinatura digital em documentos PDF.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no label de dinheiro(R$) nas vendas.'
      },
      {
        tipo: 'edit',
        texto: 'Desbloqueando botões do modal de visitas para usuários com permissão personalizada.'
      }
    ]
  },
  {
    versao: '2.38.55',
    data: '04/07/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Permitindo exibição do botão de Retornar venda para usuários com permissão personalizada.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da formatação de custo do PDF da agenda.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada a funcionalidade de manipulação de preços com números inteiros.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado totais de custo e atendimentos no relatório simples de Pagamentos por Agendamentos.'
      }
    ]
  },
  {
    versao: '2.38.54',
    data: '02/07/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção ao salvar código TISS ou SIMPRO em materiais.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da formatação de custo do PDF completo de Pagamentos por Agendamentos.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no tratamento de casas decimais nos valores de pagamentos e recebimentos.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado totais de custo e atendimentos no relatório simples de Pagamentos por Agendamentos.'
      }
    ]
  },
  {
    versao: '2.38.53',
    data: '01/07/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado juros, descontos e multas nos processos de recebimento e pagamento do financeiro.'
      },
      {
        tipo: 'bug',
        texto: 'Correção para salvar edição em um procedimento de prescrição de enfermagem.'
      }
    ]
  },
  {
    versao: '2.38.52',
    data: '30/06/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado nome do profissional da visita e horário exato da aplicação nos PDFs das prescrições.'
      },
      {
        tipo: 'add',
        texto: 'Implementando o modelo de excel em vendas e orçamentos.'
      },
      {
        tipo: 'add',
        texto: 'Implementando formato(CSV) em relatório de pagamento.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido exibição do código TISS no cadastro de materiais.'

      }
    ]
  },
  {
    versao: '2.38.51',
    data: '27/06/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Removida a obrigatoriedade de informar data de início e data de término na prescrição para geração de PFDS.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no acréscimo e desconto das compras.'
      },
      {
        tipo: 'bug',
        texto: 'Correção para salvar as etapas de procedimento específicas de cada item nas prescrições de enfermagem.'
      }
    ]
  },
  {
    versao: '2.38.50',
    data: '26/06/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção da exibição do valor da parcela na compra.'
      }
    ]
  },
  {
    versao: '2.38.49',
    data: '25/06/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção do valor total com desconto na venda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção para salvar e exibir a data de validade nos links de formulários.'
      }
    ]
  },
  {
    versao: '2.38.48',
    data: '24/06/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ajuste para selecionar automaticamente todos os profissionais do modelo de contratação definido no tipo para nova folha de pagamento.'
      }
    ]
  },
  {
    versao: '2.38.47',
    data: '23/06/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ajustes na exibição dos preços em compras e vendas.'
      }, {
        tipo: 'bug',
        texto: 'Correção no label de preços.'
      }
    ]
  },
  {
    versao: '2.38.46',
    data: '20/06/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigido problema ao faturar e retornar venda.'
      }
    ]
  },
  {
    versao: '2.38.45',
    data: '17/06/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Implementado o salvamento consistente dos filtros na impressão de visitas.'
      },
      {
        tipo: 'add',
        texto: 'Nova coluna "Data Nascimento" adicionado no PDF simples de profissionais.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias de layout nos PDFs de profissionais.'
      }
    ]
  },
  {
    versao: '2.38.44',
    data: '16/06/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção da aplicação de desconto adicionado através da folha de pagamento para criar pagamentos.'
      }
    ]
  },
  {
    versao: '2.38.43',
    data: '12/06/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção ao adicionar procedimento na prescrição de enfermagem.'
      }
    ]
  },
  {
    versao: '2.38.42',
    data: '11/06/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada entrada de lote com dispensação automática vinculada ao paciente selecionado.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado filtro por serviço na listagem de visitas.'
      },
      {
        tipo: 'edit',
        texto: 'Implementada melhoria de desempenho na funcionalidade de busca de profissionais.'
      }
    ]
  },
  {
    versao: '2.38.41',
    data: '11/06/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Remoção de bloqueio para faturar venda sincronizada que possui conflito com compra sincronizada. Permitirá o faturamento da venda e a geração de Conta da Receber, porém não irá gerar uma nova compra, evitando duplicações!'
      }
    ]
  },
  {
    versao: '2.38.40',
    data: '10/06/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada área de Cadastros > Modelos de formulários para que possam ser utilizados externamente ao site.'
      },
      {
        tipo: 'bug',
        texto: 'Correção do valor da parcela no contas receber.'
      },
      {
        tipo: 'bug',
        texto: 'Correção para gerar contas a partir do faturamento de vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao gerar PDF da prescrição médica.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da impressão de relatório de vendas e orçamentos.'
      }
    ]
  },
  {
    versao: '2.38.39',
    data: '09/06/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção para viabilizar impressão do pdf de prescrições semanais reportadas.'
      }
    ]
  },
  {
    versao: '2.38.39',
    data: '06/06/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria nas contas bancárias.'
      }
    ]
  },
  {
    versao: '2.38.38',
    data: '03/06/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria na performace da impressão da agenda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na busca da tabela de cadastro de materiais.'
      },
      {
        tipo: 'bug',
        texto: 'Correção nos tipos de estoque.'
      }
    ]
  },
  {
    versao: '2.38.37',
    data: '02/06/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado permissão de acesso a mais cards do dashboard no acesso de secretário(a).'
      },
      {
        tipo: 'edit',
        texto: 'Ajuste de layout no PDF de agendamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de sobreposição de custo do serviço na agenda do paciente.'
      }
    ]
  },
  {
    versao: '2.38.36',
    data: '30/05/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria de performance na impressão da agenda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no calculo de meses anteriores no extrato de contas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao gerar PDF da prescrição médica.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na criação do evento.'
      }
    ]
  },
  {
    versao: '2.38.35',
    data: '29/05/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado nova coluna no estoque do paciente para diferenciar material de medicamento.'
      },
      {
        tipo: 'edit',
        texto: 'Separação da lista de materiais em estoque materiais.'
      },
      {
        tipo: 'edit',
        texto: 'Ajuste no layout dos PDFs de Vendas/Orçamentos.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria de performance na impressão da agenda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da sobreposição de custo do evento copiado na agenda do paciente.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no campo de busca do cadastro de produtos.'
      }
    ]
  },
  {
    versao: '2.38.34',
    data: '28/05/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no cadastro da assinatura eletrônica.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da sobreposição de custo do evento copiado na agenda do paciente.'
      }
    ]
  },
  {
    versao: '2.38.33',
    data: '21/05/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção nas somas do PDF de pagamentos.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada a opção de filtrar o relatório de saldo de pedidos por paciente.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado possibilidade de habilitar e desativar pop-up de notificações na interface.'
      }
    ]
  },
  {
    versao: '2.38.32',
    data: '16/04/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado nova opção "Uretral-SVD" para via de administração.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado suporte para múltiplos responsáveis no modelo de documento, permitindo o uso de tags personalizadas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção nos aditivos da venda no Contas a Receber.'
      }
    ]
  },
  {
    versao: '2.38.31',
    data: '13/04/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de erros de cálculo para valores zerados em novas folhas de pagamento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na data da parcela nas despesas.'
      },
      {
        tipo: 'bug',
        texto: 'Correções feitas na sincronização da venda.'
      }
    ]
  },
  {
    versao: '2.38.30',
    data: '12/04/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigido inversão das colunas no relatório da agenda do paciente.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias na performace no estoque de materiais.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido botões de "Faturar" e "Retornar" vendas.'
      }
    ]
  },
  {
    versao: '2.38.29',
    data: '28/04/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ordenação das visitas por data no relatório de visitas.'
      }
    ]
  },
  {
    versao: '2.38.28',
    data: '24/04/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ajuste da coloração dos botões.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado nova coluna na dispensação para exibir quantidade restante a se dispensar.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado novo ícone para na lista de dispensações para exibir dialog com itens a dispensar.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias no layout da lista de dispensações.'
      },
      {
        tipo: 'bug',
        texto: 'Ajuste feito no card de eventos na agenda.'
      }
    ]
  },
  {
    versao: '2.38.27',
    data: '22/04/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção na exibição do custo do serviço ao editar evento na agenda.'
      }
    ]
  },
  {
    versao: '2.38.26',
    data: '17/04/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Adicionado a opção Via inalatória nas prescrições como Via de administração e Unidade Adesivo.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no disparo das mensagens no Aplicativo.'
      },
      {
        tipo: 'edit',
        texto: 'Ordenação dos avisos por visualização.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada a opção de impressão dos sinais vitais.'
      }
    ]
  },
  {
    versao: '2.38.25',
    data: '16/04/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção na prioridade de custo do profissional na agenda.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada nova unidade "UI - Unidade internacional" nas prescrições.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada configuração com possibilidade de iniciar visita retroativa em evento passado.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada configuração para exigir obrigatoriedade da assinatura do responsável pelo paciente ao encerrar visita.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada configuração para filtrar botões que aparecerão para os profissionais na abertura da visita.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada configuração para permitir iniciar visita somente no mês vigente.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada configuração para a empresa permitir rastreio do profissional durante visita pelo app.'
      }
    ]
  },
  {
    versao: '2.38.24',
    data: '11/04/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhorias nos filtros de pesquisa.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no botão de "Fazer Dispensação" em Farmácia.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na data das despesas.'
      }
    ]
  },
  {
    versao: '2.38.23',
    data: '07/04/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ajuste de posicionamente na assinatura dos PDFs.'
      }
    ]
  },
  {
    versao: '2.38.22',
    data: '02/04/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Adicionado texto explicativo do funcionamento de vendas sincronizadas no momento da inativação.'
      },
      {
        tipo: 'bug',
        texto: 'Ajuste feito no preço do evento editado.'
      },
      {
        tipo: 'bug',
        texto: 'Ajuste feito na sincrinização dos serviços das vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigindo exclusão e reativação de vendas.'
      }
    ]
  },
  {
    versao: '2.38.21',
    data: '28/03/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigido acesso personalizado à área de Cadastros > Fornecedores e Clientes.'
      }
    ]
  },
  {
    versao: '2.38.20',
    data: '26/03/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado checkbox "Remover texto Prescrição Vencida" no diálogo de impressão.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias nos avisos do menu estoque.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias de performance no dashboard agendamentos.'
      },
      {
        tipo: 'edit',
        texto: 'Ajuste no PDF de vendas e orçamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Ajuste realizado para não haver duplicação de cards no dashboard.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no card alertas de sinais no dashboard.'
      },
      {
        tipo: 'bug',
        texto: 'Correção nas assinaturas.'
      }
    ]
  },
  {
    versao: '2.38.19',
    data: '25/03/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Novo botão adicionado ao card do paciente, permitindo a atribuição de preços personalizados para produtos e serviços.'
      },
      {
        tipo: 'bug',
        texto: 'Ajustes nas observações exibidas no relatório de Pagamentos por Agendamentos.'
      }
    ]
  },
  {
    versao: '2.38.18',
    data: '24/03/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Adicionado filtro para o período das observações do relatório de Pagamentos por Agendamentos.'
      }
    ]
  },
  {
    versao: '2.38.17',
    data: '21/03/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Correção do custo do profissional no relatório da agenda.'
      }
    ]
  },
  {
    versao: '2.38.16',
    data: '18/03/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria na performance dos relatórios de rendição e de pagamentos por agendamentos.'
      }
    ]
  },
  {
    versao: '2.38.15',
    data: '15/03/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ajustes no estilo dos cards notificações e estoque.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na performace do dashboard.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no modelo acompanhamento familiar.'
      }
    ]
  },
  {
    versao: '2.38.14',
    data: '14/03/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigido erro ao ativar filtragens sem adicionar as informações no relatório de folhas de pagamento.'
      }
    ]
  },
  {
    versao: '2.38.13',
    data: '13/03/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhorias na performace do dashboard.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido carregamento dos relatórios de status.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido erro de formato de datas de prescrição.'
      }
    ]
  },
  {
    versao: '2.38.12',
    data: '11/03/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Paginação no card de Notificações.'
      },
      {
        tipo: 'add',
        texto: 'Permissões personalizadas para os cards de profissionais e pacientes.'
      },
      {
        tipo: 'edit',
        texto: 'Otimizada performance para gerar relatório simples de agendamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigida ausência da informação de tabela nos produtos para a área de pacote.'
      }
    ]
  },
  {
    versao: '2.38.11',
    data: '07/03/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada permissão personalizada para usuários a partir da barra de menus do site.'
      }
    ]
  },
  {
    versao: '2.38.10',
    data: '06/03/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no preço de serviços.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na performace do card de estoque.'
      }
    ]
  },
  {
    versao: '2.38.09',
    data: '28/02/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria consulta notificações.'
      },
      {
        tipo: 'add',
        texto: 'Nova funcionalidade de dispensação urgente em farmácia.'
      }
    ]
  },
  {
    versao: '2.38.08',
    data: '27/02/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria na área de sugestão de profissional no agendamento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção nos cards de profissionais, com a atualização de especialidades e buscas corrigidas.'
      }
    ]
  },
  {
    versao: '2.38.07',
    data: '24/02/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada data de vencimento do registro de especialidade do profissional.'
      }
    ]
  },
  {
    versao: '2.38.07',
    data: '14/02/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada nova funcionalidade de dispensação urgente em Farmácia.'
      }
    ]
  },
  {
    versao: '2.38.06',
    data: '10/02/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada configuração de sugestão de profissional em agendamentos.'
      }
    ]
  },
  {
    versao: '2.38.05',
    data: '03/02/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no dashboard em agendamentos do dia.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao imprimir modelo de documentos.'
      },
      {
        tipo: 'edit',
        texto: 'Ajustada exibição dos botões de indicadores na janela de visitas.'
      }
    ]
  },
  {
    versao: '2.38.04',
    data: '31/01/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novas tags em modelos de documentos.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado novos campos de dados no PDF de orçamentos por período.'
      },
      {
        tipo: 'edit',
        texto: 'Mudança para salvar somente as informações alteradas nas janelas de preços em Convênios, Produtos e Fornecedores.'
      }
    ]
  },
  {
    versao: '2.38.03',
    data: '29/01/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado nova coluna data vencimento na tabela de vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção nas datas da dispensação.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na exibição dos dados dos produtos.'
      }
    ]
  },
  {
    versao: '2.38.02',
    data: '28/01/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada melhoria na performance de paginação de produtos na área de Pacote, Kit, Financeiro e Farmácia.'
      }
    ]
  },
  {
    versao: '2.38.01',
    data: '23/01/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionadas informações bancárias ao excel do relatório de pagamentos por agendamentos.'
      }
    ]
  },
  {
    versao: '2.38.00',
    data: '22/01/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada opção de frações nos preços dos convênios.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada opção de Mostrar outros pacientes e/ou profissionais no mapa.'
      }
    ]
  },
  {
    versao: '2.37.16',
    data: '21/01/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Ajuste feito nas datas de entrada e saída.'
      }
    ]
  },
  {
    versao: '2.37.15',
    data: '17/01/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novas tags no modelos de documento.'
      },
      {
        tipo: 'edit',
        texto: 'Atualização no dashboard.'
      }
    ]
  },
  {
    versao: '2.37.14',
    data: '13/01/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Atualização de agendamentos do dia no dashboard.'
      },
      {
        tipo: 'edit',
        texto: 'Implementado novo layout do PDF de evoluções.'
      }
    ]
  },
  {
    versao: '2.37.13',
    data: '10/01/2025',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Implementação do novo acesso comercial.'
      },
      {
        tipo: 'bug',
        texto: 'Ajuste no PDF escala.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na visualização de aplicações de prescrições - visitas.'
      }
    ]
  },
  {
    versao: '2.37.12',
    data: '09/01/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção na sincronização da agenda em vendas.'
      }
    ]
  },
  {
    versao: '2.37.11',
    data: '08/01/2025',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no PDF de evoluções em visitas.'
      },
      {
        tipo: 'edit',
        texto: 'Permitida a inclusão de novos produtos ou serviços existentes na venda.'
      },
      {
        tipo: 'edit',
        texto: 'Adicionando novas informações ao PDF de escala.'
      }
    ]
  },
  {
    versao: '2.37.10',
    data: '07/01/2025',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Separação de serviços iguais com preços diferentes na sincronização da agenda em vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências em relatórios e quantidades de relatórios de prescrição, com ou sem associação a venda.'
      }
    ]
  },
  {
    versao: '2.37.09',
    data: '17/12/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de (Arquivos em nuvem) em equipamentos.'
      }
    ]
  },
  {
    versao: '2.37.08',
    data: '13/12/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhorar na exibição dos campos de preenchimento de datas em relatórios.'
      }
    ]
  },
  {
    versao: '2.37.07',
    data: '10/12/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado histórico de alterações em produtos e lotes.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada possibilidade de baixar .zip de relatórios completos de pagamentos por agendamentos com um arquivo para cada profissional.'
      },
      {
        tipo: 'edit',
        texto: 'Alteração para exibir somente os itens respondidos para os indicadores de saúde nos relatórios de visitas.'
      }
    ]
  },
  {
    versao: '2.37.06',
    data: '05/12/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Criado bloqueio para faturar vendas sincronizadas com agenda quando tiver uma compra de um profissional sincronizada com Agenda para um mesmo período.'
      },
      {
        tipo: 'edit',
        texto: 'Ajustes para melhoria de performance em atualização de visitas.'
      }
    ]
  },
  {
    versao: '2.37.05',
    data: '02/12/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Otimização ao criar/editar eventos e visitas no site.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada configuração de instituição para permitir exibição de custos na agenda do profissional pelo aplicativo.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na formatação do custo dos relatórios de agendamentos.'
      }
    ]
  },
  {
    versao: '2.37.04',
    data: '28/11/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Otimização de consultas na agenda de profissionais e pacientes.'
      }
    ]
  },
  {
    versao: '2.37.03',
    data: '27/11/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado status de atendimento "Gerenciamento crônico (Roxo)" ao filtro.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado data de vencimento nas configurações gerais da compra.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada funcionalidade para registrar a data de início das prescrições de enfermagem.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na categoria da configuração de compra quando criada a partir de uma venda.'
      }
    ]
  },
  {
    versao: '2.37.02',
    data: '25/11/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'O profissional do evento é atualizado quando outro realiza a visita através do evento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na contagem de agendamentos dos profissionais no PDF de escalas.'
      }
    ]
  },
  {
    versao: '2.37.01',
    data: '25/11/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'O profissional do evento é atualizado quando outro realiza a visita através do evento.'
      }
    ]
  },
  {
    versao: '2.37.01',
    data: '25/11/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'O profissional do evento é atualizado quando outro realiza a visita através do evento.'
      }
    ]
  },
  {
    versao: '2.37.01',
    data: '21/11/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionados gráficos detalhados para relatórios de Indicadores de saúde.'
      }
    ]
  },
  {
    versao: '2.37.00',
    data: '18/11/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionados Indicadores de saúde.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado o resumo de quantos atendimentos cada profissional tem.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado relatório de manutenção de equipamentos em Excel.'
      },
      {
        tipo: 'bug',
        texto: 'Correção para salvar dados bancários do profissional ao salvar folha de pagamento.'
      }
    ]
  },
  {
    versao: '2.36.19',
    data: '03/11/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Implementada nova funcionalidade de relatório de pacientes em Excel.'
      }
    ]
  },
  {
    versao: '2.36.18',
    data: '05/11/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Implementado campo de idade para cadastro de paciente sem necessidade de data de nascimento.'
      },
      {
        tipo: 'add',
        texto: 'Implementado novo tipo de status do atendimento no paciente.'
      },
      {
        tipo: 'add',
        texto: 'Realizada a implementação do novo estado civil.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigidos preços de visitas exibidos em relatórios.'
      }
    ]
  },
  {
    versao: '2.36.17',
    data: '04/11/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Correção de datas no excel do relatório de agendamentos por pagador.'
      }
    ]
  },
  {
    versao: '2.36.16',
    data: '24/10/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado nova opção de escala recorrente.'
      }
    ]
  },
  {
    versao: '2.36.15',
    data: '23/10/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigida impressão de folhas de pagamento sem campos na área de "Base".'
      },
      {
        tipo: 'edit',
        texto: 'Alteração da cor do botão de adicionar especialidade do profissional.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a possibilidade de realizar impressão da agenda do profissional e do paciente.'
      }
    ]
  },
  {
    versao: '2.36.14',
    data: '15/10/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Ajuste na sobreposição de datas no relatório agenda do profissional.'
      }
    ]
  },
  {
    versao: '2.36.13',
    data: '11/10/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de excel em contas a pagar e contas a receber.'
      }
    ]
  },
  {
    versao: '2.36.12',
    data: '10/10/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado registro do criador do paciente na ficha e relatório dos pacientes.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado total de pacientes cadastrados por profissional no relatório dos pacientes.'
      }
    ]
  },
  {
    versao: '2.36.1',
    data: '08/10/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Correção de alinhamento no card de acompanhamento familiar.'
      }
    ]
  },
  {
    versao: '2.36.10',
    data: '03/10/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novas opções de filtros nos pacientes.'
      }
    ]
  },
  {
    versao: '2.36.09',
    data: '01/10/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção na conta bancária de terceiros ao gerar pagamentos bancários.'
      }
    ]
  },
  {
    versao: '2.36.08',
    data: '26/09/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no filtro período de datas do relatório agendamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na mensagem de conflito de eventos.'
      }
    ]
  },
  {
    versao: '2.36.07',
    data: '25/09/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novo card no dashboard para filtrar os agendamentos do dia atual.'
      }
    ]
  },
  {
    versao: '2.36.06',
    data: '24/09/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Atualização das informações dos eventos associados a visitas criadas com informações distintas das previstas.'
      }
    ]
  },
  {
    versao: '2.36.05',
    data: '22/09/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção da reatividade na página de Pacientes e Profissionais ao adicionar novo.'
      }
    ]
  },
  {
    versao: '2.36.04',
    data: '20/09/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de formatação nos PDFs.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado filtro nos serviços do profissional selecionado na agenda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da paginação de evoluções.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na adição de kits nas vendas.'
      }
    ]
  },
  {
    versao: '2.36.03',
    data: '19/09/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no botão de assinatura.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na impressão do PDF de orçamentos.'
      }
    ]
  },
  {
    versao: '2.36.02',
    data: '17/09/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correções nos botões de anexos.'
      },
      {
        tipo: 'add',
        texto: 'Inserido campos de assinatura no relatório parcial da dispensação em farmácia.'
      }
    ]
  },
  {
    versao: '2.36.01',
    data: '16/09/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigido funcionamento do botão de anexo na farmácia.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a possibilidade realizar múltiplas visitas simultaneamente.'
      }
    ]
  },
  {
    versao: '2.36.00',
    data: '14/09/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ajuste nas datas de visitas.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria da performance/carregamento nas telas de Pacientes e Profissionais.'
      },
      {
        tipo: 'edit',
        texto: 'Nova interface da tela de Avisos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na nomenclatura dos relatórios de venda e orçamento.'
      }
    ]
  },
  {
    versao: '2.35.60',
    data: '11/09/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria no salvamento de datas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado dedução administrativa.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado dedução administrativa no balanço.'
      }
    ]
  },
  {
    versao: '2.35.59',
    data: '09/09/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Otimizados PDFs de visitas para reduzir o tempo de impressão.'
      },
      {
        tipo: 'bug',
        texto: 'Correção do botão gerar balanço em vendas.'
      }
    ]
  },
  {
    versao: '2.35.58',
    data: '06/09/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria na tag de sequências do XML.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na configuração padrão de vendas e compras.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na duplicidade do XML.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na quantidade ao adicionar novos medicamentos em compras.'
      }
    ]
  },
  {
    versao: '2.35.57',
    data: '05/09/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhorias de layout em relatórios.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na data de processamento dos boletos.'
      }
    ]
  },
  {
    versao: '2.35.56',
    data: '04/09/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de ocultar valores monetários no relatório de vendas.'
      }
    ]
  },
  {
    versao: '2.35.55',
    data: '03/09/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de excel no relatório de acompanhamento familiar.'
      },
      {
        tipo: 'edit',
        texto: 'Filtrando consultas de Compras por mês e ano, otimizando performance.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na exibição de prescrições com itens ordenados manualmente.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na filtragem de visitas.'
      }
    ]
  },
  {
    versao: '2.35.54',
    data: '02/09/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no botão alterar data do aditivo de orçamento.'
      }
    ]
  },
  {
    versao: '2.35.53',
    data: '28/08/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no carregamento das visitas.'
      }
    ]
  },
  {
    versao: '2.35.52',
    data: '27/08/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção na localização das visitas.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na ordenação no relatório do XML.'
      },
      {
        tipo: 'bug',
        texto: 'Correção nas dispensações.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na busca de contas.'
      }
    ]
  },
  {
    versao: '2.35.51',
    data: '26/08/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Implementação do novo PDF de acompanhamento Familiar.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no carregamento das visitas.'
      }
    ]
  },
  {
    versao: '2.35.50',
    data: '22/08/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria no DRE.'
      }
    ]
  },
  {
    versao: '2.35.49',
    data: '21/08/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no campo de preço de visita não agendada.'
      },
      {
        tipo: 'bug',
        texto: 'Correção do botão imprimir dispensação.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nas datas das operações.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no gráfico de receitas e despesas no dashboard financeiro.'
      },
      {
        tipo: 'bug',
        texto: 'Correção nos PDFs dos orçamentos.'
      }
    ]
  },
  {
    versao: '2.35.48',
    data: '20/08/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no PDF de dispensações..'
      }
    ]
  },
  {
    versao: '2.35.47',
    data: '19/08/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado Responsável pela conferência no PDF dispensação em Farmácia.'
      }
    ]
  },
  {
    versao: '2.35.46',
    data: '14/08/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionadas configurações padrão para vendas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionadas configurações padrão para orçamentos.'
      },
      {
        tipo: 'add',
        texto: 'Adicionadas configurações padrão para compras.'
      },
      {
        tipo: 'add',
        texto: 'Adicionadas configurações padrão para despesas.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na seleção de categorias de receitas e despesas.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigida filtragem de profissionais e especialidades na listagem de visitas'
      },
      {
        tipo: 'bug',
        texto: 'Correção na geração do XML.'
      }
    ]
  },
  {
    versao: '2.35.45',
    data: '13/08/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada opções no filtro do gráfico de sinais vitais.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da filtragem de todos os itens da tabela de visitas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na impressão de visitas padrão.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no endereço que não estava sendo exibido no pdf de visitas.'
      }
    ]
  },
  {
    versao: '2.35.44',
    data: '13/08/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no PDF lista presencial.'
      }
    ]
  },
  {
    versao: '2.35.43',
    data: '12/08/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Adicionada paginação para os resultados de visitas no site para otimização de performance.'
      },
      {
        tipo: 'edit',
        texto: 'Adicionada informação de carregando impressão quando selecionar imprimir relatório de visitas.'
      }
    ]
  },
  {
    versao: '2.35.42',
    data: '09/08/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a permissão para adicionar equipamentos repetidos nas vendas.'
      }
    ]
  },
  {
    versao: '2.35.41',
    data: '08/08/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado filtro no PDF completo de vendas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado à prorrogação de vendas.'
      }
    ]
  },
  {
    versao: '2.35.40',
    data: '07/08/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada filtragem de visitas por período inicial e final no site.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no PDF de Guia TISS na versão 4.01.00.'
      }
    ]
  },
  {
    versao: '2.35.39',
    data: '06/08/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionados PDF de Guia TISS na versão 4.01.00.'
      }
    ]
  },
  {
    versao: '2.35.38',
    data: '05/08/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção na tabela do Contas a Pagar'
      },
      {
        tipo: 'add',
        texto: 'Adicionados cálculos automáticos em folhas de pagamento.'
      }
    ]
  },
  {
    versao: '2.35.37',
    data: '02/08/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no filtro categorias.'
      }
    ]
  },
  {
    versao: '2.35.36',
    data: '01/08/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no endereço do PDF visitas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada a opção de filtrar contas a pagar por banco.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na sincronização dos serviços realizados pelo profissional ao sincronizar agendamentos com vendas.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no carregamento dos cards do dashboard.'
      }
    ]
  },
  {
    versao: '2.35.35',
    data: '31/07/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção do custo nas visitas não previstas.'
      }
    ]
  },
  {
    versao: '2.35.34',
    data: '30/07/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada a funcionalidade para anexar documentos às vendas.'
      }
    ]
  },
  {
    versao: '2.35.33',
    data: '27/07/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção da reatividade dos campos não sincronizados à agenda quando houver sincronização da folha de pagamento.'
      }
    ]
  },
  {
    versao: '2.35.32',
    data: '26/07/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção das observações no pdf de prescrições.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada na área de Gestão de pessoas a opção de excluir múltiplas folhas de pagamento, além de viabilizar abrir ou finalizar múltiplas compras associadas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao abrir e editar prescrições.'
      },
      {
        tipo: 'bug',
        texto: 'Correções e melhoria nos pagamentos bancários.'
      }
    ]
  },
  {
    versao: '2.35.31',
    data: '25/07/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Cores adicionadas ao PDF de prescrições.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no dígito da agência nos dados bancários.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no históricso dos pacientes.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na busca de contas bancários.'
      }
    ]
  },
  {
    versao: '2.35.30',
    data: '24/07/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Adicionadas informações de valores (crédito, débito, valor líquido, quantidade de serviços e totais) na tabela e PDF de relatório de folha de pagamento.'
      },
      {
        tipo: 'edit',
        texto: 'Criado bloqueio para  múltiplo clique evitando salvar múltiplas folhas de pagamento repetidas.'
      },
      {
        tipo: 'edit',
        texto: 'Exibindo por padrão a filtragem de prescrições médicas e de dieta por Período de aplicação.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de campos duplicados nas folhas de pagamento ao gerar folha sincronizada à agenda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da impressão de relatório de folhas de pagamento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção das prescrições de dieta apresentadas na tela.'
      }
    ]
  },
  {
    versao: '2.35.29',
    data: '23/07/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria nas compras geradas por agendamentos.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na performance de vendas.'
      }
    ]
  },
  {
    versao: '2.35.28',
    data: '22/07/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ajustada paginação de prescrições médicas para melhoria na performance (paginação por Data de criação ou Período de aplicação).'
      }
    ]
  },
  {
    versao: '2.35.27',
    data: '20/07/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no relatório de dispensação na farmácia.'
      }
    ]
  },
  {
    versao: '2.35.26',
    data: '19/07/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Revertida temporariamente a alteração na paginação de prescrições médicas.'
      }
    ]
  },
  {
    versao: '2.35.25',
    data: '19/07/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado card para visualização do histórico de notificações no dashboard.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a coluna status no relatório EXCEL de pagamentos por pagador.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no relatório EXCEL da agenda do paciente.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na sincronização inicial das vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na filtragem de prescrições médicas.'
      },
      {
        tipo: 'edit',
        texto: 'Ajustada paginação de prescrições médicas para melhoria na performance.'
      }
    ]
  },
  {
    versao: '2.35.24',
    data: '18/07/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria na sincronização das visitas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no relatório de pagamentos por vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no espaçamento no PDF de evoluções.'
      }
    ]
  },
  {
    versao: '2.35.23',
    data: '17/07/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção para salvar eventos e verificar bloqueio somente se estiver associado a uma folha de pagamento sincronizada dentro do período.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na busca de eventos disponíveis para paciente na área de visitas.'
      }
    ]
  },
  {
    versao: '2.35.22',
    data: '16/07/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção na edição de visitas pelo site.'
      }
    ]
  },
  {
    versao: '2.35.21',
    data: '15/07/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção na geração de faturamento XML.'
      },
      {
        tipo: 'bug',
        texto: 'Correção do PDF de visitas padrão.'
      }
    ]
  },
  {
    versao: '2.35.20',
    data: '14/07/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ajustado login para melhoria na performance.'
      },
      {
        tipo: 'bug',
        texto: 'Correções de inconsistências em folhas de pagamento sincronizadas à agenda.'
      }
    ]
  },
  {
    versao: '2.35.19',
    data: '12/07/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção do PDF de visitas.'
      }
    ]
  },
  {
    versao: '2.35.18',
    data: '11/07/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção nos agendamentos recusados da tela inicial.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado endereço no PDF de visitas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado modelo de impressão Pagamentos PIX (EXCEL) no contas a pagar.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de visitas não previstas ao associar a vendas.'
      }
    ]
  },
  {
    versao: '2.35.17',
    data: '10/07/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado endereço no PDF de visitas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado modelo de impressão Pagamentos PIX (EXCEL) no contas a pagar.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de visitas não previstas ao associar a vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no financeiro.'
      }
    ]
  },
  {
    versao: '2.35.16',
    data: '05/07/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Adicionado no botão Usuário e senha, no card do profissional, opção de visualizar menu de Gestão de Pessoas como nova permissão de usuário para gerente.'
      }
    ]
  },
  {
    versao: '2.35.15',
    data: '02/07/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção da permissão das funcionalidades de Gestão de Pessoas para clientes com Módulo Financeiro ativo.'
      }
    ]
  },
  {
    versao: '2.35.14',
    data: '01/07/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção do código da tabela ao associar pacotes às vendas.'
      }
    ]
  },
  {
    versao: '2.35.13',
    data: '28/06/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado o campo CPF/CNPJ da conta em dados bancários.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção inserir imagem na informação exibida no final do arquivo de impressão das vendas.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no PDF de lista presencial.'
      }
    ]
  },
  {
    versao: '2.35.12',
    data: '27/06/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção na verificação de pacotes dos pacientes, seus respectivos bloqueios e liberações.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na exibição de agendamentos coringa.'
      }
    ]
  },
  {
    versao: '2.35.11',
    data: '26/06/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção na clonagem das prescrições.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na data de início dos medicamentos das prescrições.'
      }
    ]
  },
  {
    versao: '2.35.10',
    data: '25/06/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado histórico de preços nas vendas.'
      },
      {
        tipo: 'edit',
        texto: 'Adicionada informação na tabela de compras das compras sincronizadas com agendamentos e o seu período.'
      },
      {
        tipo: 'bug',
        texto: 'Correção nas compras geradas por agendamentos.'
      }
    ]
  },
  {
    versao: '2.35.9',
    data: '24/06/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria no tempo de carregamento de Agenda de profissionais e pacientes.'
      }
    ]
  },
  {
    versao: '2.35.8',
    data: '21/06/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria nas despesas.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nas contas a pagar.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na data de início do item da prescrição.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na impressão do PDF de prescrição.'
      }
    ]
  },
  {
    versao: '2.35.7',
    data: '20/06/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria com a exibição de mais informações de visita na agenda de Visitas à empresa.'
      }
    ]
  },
  {
    versao: '2.35.6',
    data: '19/06/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria nas permissões das assinaturas.'
      }
    ]
  },
  {
    versao: '2.35.5',
    data: '18/06/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado data de manutenção em estoque de equipamentos'
      },
      {
        tipo: 'add',
        texto: 'Adicionado campo de data de pagamento em pagamentos'
      },
      {
        tipo: 'add',
        texto: 'Adicionado campo de data de recebimento em recebimentos'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nas folhas de pagamento sincronizadas com agenda para permitir associar com paciente e criar múltiplas folhas de um mesmo profissional'
      },
      {
        tipo: 'bug',
        texto: 'Correção de bug em data de pagamento'
      }
    ]
  },
  {
    versao: '2.35.4',
    data: '14/06/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção dos horários de produtos nas vendas'
      }
    ]
  },
  {
    versao: '2.35.3',
    data: '13/06/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campo de nota fiscal em compras.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de erro de quantidade em vendas.'
      }
    ]
  },
  {
    versao: '2.35.2',
    data: '10/06/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a data de início para medicamentos na prescrição medica.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a data de início do medicamento no PDF de prescrição medica.'
      },
      {
        tipo: 'bug',
        texto: 'Correções no sistema que poderiam causar instalibidade no site.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.35.1',
    data: '09/06/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correções no sistema que poderiam causar instalibidade no site.'
      }
    ]
  },
  {
    versao: '2.35.0',
    data: '07/06/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada PDF de lista presencial.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada associação de folha de pagamento à compra sincronizada com agenda.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada reatividade nas mudanças em eventos e visitas associadas a uma compra sincronizada em aberto.'
      }
    ]
  },
  {
    versao: '2.34.26',
    data: '06/06/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria no relatório vendas por período.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nos boletos.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nas vendas recorrente.'
      }
    ]
  },
  {
    versao: '2.34.25',
    data: '03/06/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de erro na associação de pacotes à prescrição.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.24',
    data: '29/05/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados em Acompanhamento Familiar.'
      }
    ]
  },
  {
    versao: '2.34.23',
    data: '28/05/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria nas assinaturas eletrônicas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.22',
    data: '24/05/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a coluna checagem em vendas.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no resumo de informações dos pacientes e profissionais.'
      }
    ]
  },
  {
    versao: '2.34.21',
    data: '23/05/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.20',
    data: '22/05/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada a opção de definir o cabeçalho dos PDFs de visitas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada a opção de definir o responsável pelo paciente como pagador.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias na configuração de boletos.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias na criação de boletos.'
      }
    ]
  },
  {
    versao: '2.34.19',
    data: '20/05/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada filtragem por ano nas operações da conta.'
      }
    ]
  },
  {
    versao: '2.34.18',
    data: '17/05/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado o endereço do paciente aos PDFs de prescrições e dispensações.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na funcionalidade de boletos no contas a receber.'
      }
    ]
  },
  {
    versao: '2.34.17',
    data: '16/05/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria na dispensação automática.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.16',
    data: '15/05/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada o CPF no relatório de agendamentos por pagador.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada o telefone do profissional no card dos agendamentos.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção de buscar o kit.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na configuração do convênio dos boletos.'
      }
    ]
  },
  {
    versao: '2.34.15',
    data: '14/05/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada possibilidade de informar valor máximo em créditos e débitos do modelo 1 de folha de pagamento.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada filtragem para ocultar ou mostrar valores zerados de créditos e débitos em impressão de folha de pagamento.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado botão de editar folha de pagamento na tabela.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado subtítulo na janela de edição de folha de pagamento para informar quando a compra associada estiver faturada e não permitir salvar alterações.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada opção de reativar lotes.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no estorno de produtos ao estoque.'
      }
    ]
  },
  {
    versao: '2.34.14',
    data: '13/05/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a configuração para definir o período de visibilidade das visitas.'
      }
    ]
  },
  {
    versao: '2.34.13',
    data: '09/05/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado módulo de visitas à empresa.'
      }
    ]
  },
  {
    versao: '2.34.121',
    data: '08/05/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados em folhas de pagamento.'
      }
    ]
  },
  {
    versao: '2.34.12',
    data: '07/05/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.11',
    data: '02/05/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.10',
    data: '29/04/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.9',
    data: '25/04/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.8',
    data: '24/04/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado bloqueio de exclusão múltipla de eventos, exceto se usuário ativar localização ou se a instituição configurar o desbloqueio.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada função do navegador de pegar a localização do usuário para salvar informações de ações importantes realizadas pelo usuário.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada tabela que apresenta uma prévia dos eventos que serão excluídos na exclusão múltipla de eventos na Agenda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.7',
    data: '23/04/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhorias em consulta de eventos para o site e aplicativo.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.6',
    data: '19/04/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.5',
    data: '17/04/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.4',
    data: '16/04/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no cadastro da assinatura da instituição.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.3',
    data: '12/04/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando relatório de saldo de pedido na farmácia.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      },
      {
        tipo: 'add',
        texto: 'Adicionando quantidade total de profissionais no relatório de profissionais.'
      }
    ]
  },
  {
    versao: '2.34.2',
    data: '11/04/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado número de registro no relatório de profissionais.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção de profissionais editarem visitas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção de reabrir visitas.'
      }
    ]
  },
  {
    versao: '2.34.1',
    data: '09/04/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionadas novas configurações para instituição: Bloquear início de visita sem evento + Adicionar tempo de tolerância para iniciar eventos'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na sincronização das visitas'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.34.0',
    data: '08/04/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada a área de Gestão de Pessoas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada criação de Folhas de pagamentos, possibilitando associá-las a compras.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no faturamento XML.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.109',
    data: '05/04/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria no faturamento XML.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.108',
    data: '03/04/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando caixa de seleção para listar os profissionais no relatório de vendas e orçamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.107',
    data: '02/04/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na criação das vendas.'
      },
      {
        tipo: 'edit',
        texto: 'Adicionando pix no relatório de vendas e orçamentos.'
      },
      {
        tipo: 'edit',
        texto: 'Adicionando data de vencimento no relatório de vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.106',
    data: '01/04/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando forma de pagamento no relatório de vendas e orçamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.105',
    data: '28/03/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando campo de formas de pagamentos em vendas e orçamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.104',
    data: '27/03/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando opção de baixar prescrição médica assinada em visitas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionando assinatura para o relatório de vendas e orçamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.103',
    data: '26/03/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Registro do histórico da agenda adicionado para o paciente.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.102',
    data: '25/03/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.101',
    data: '22/03/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no PDF de contas a pagar.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.100',
    data: '21/03/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Correção e melhoria nas Prescrições médicas feitas pelos profissionais.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.99',
    data: '20/03/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.98',
    data: '18/03/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de compras resultantes de agendamentos.'
      }
    ]
  },
  {
    versao: '2.33.97',
    data: '15/03/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      },
      {
        tipo: 'add',
        texto: 'Implementada a funcionalidade de criação de prescrições médicas pelos profissionais.'
      },
      {
        tipo: 'add',
        texto: 'adicionando a possibilidade de salvar as configurações de impressão do relatorio de visitas'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.96',
    data: '14/03/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.95',
    data: '13/03/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Implementada a funcionalidade para exclusão do cadastro de assinatura do profissional.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.94',
    data: '12/03/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Implementada a adição de filtros para as compras originadas de agendamentos'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências reportadas na exibição do preço de pacotes em eventos, visitas e vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.93',
    data: '10/03/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.92',
    data: '08/03/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria nas assinaturas'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.91',
    data: '07/03/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de exibir o responsável no PDF de escala.'
      }
    ]
  },
  {
    versao: '2.33.90',
    data: '05/03/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.89',
    data: '01/03/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção para excluir imagens das evoluções.'
      }
    ]
  },
  {
    versao: '2.33.88',
    data: '28/02/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.87',
    data: '27/02/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado formato pdf para impressão do relatório de agendamentos por pagador.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.86',
    data: '26/02/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando coluna de evolução no relatório de agendamento'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.85',
    data: '23/02/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada opção de imprimir por tipo de pagador os relatórios simples e completos de Acompanhamento Familiar na área de Cadastros.'
      }
    ]
  },
  {
    versao: '2.33.84',
    data: '22/02/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionados relatórios simples e completos de Acompanhamento Familiar na área de Cadastros.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      },
      {
        tipo: 'add',
        texto: 'Adicionando relatório de pagamento por vendas dos profissionais em excel e adicionando a opcao de selecionar pis ou pix no relatorio simples de pagamentos agendados.'
      }
    ]
  },
  {
    versao: '2.33.83',
    data: '21/02/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção buscar código no convênio.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.82',
    data: '20/02/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria nas tabelas brasíndice.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nos aditivos de vendas.'
      }
    ]
  },
  {
    versao: '2.33.81',
    data: '16/02/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada a opção de criar modelos de Acompanhamento Familiar para serem preenchidos pelos gestores e no módulo do paciente. O controle de aplicação poderá ser visualizado através de card na área Inicial da empresa e de notificações.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.80',
    data: '10/02/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Adicionado a opção da assinatura eletrônica para visitas'
      }
    ]
  },
  {
    versao: '2.33.79',
    data: '06/02/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ordenando o campo de profissionais por ordem alfabética em vendas'
      }
    ]
  },
  {
    versao: '2.33.78',
    data: '05/02/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ordenando os campos de pacientes e profissionais por ordem alfabética em avisos'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.77',
    data: '02/02/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria na conciliação bancária.'
      },
      {
        tipo: 'edit',
        texto: 'Ajustando espaçamento na tela de vendas.'
      }
    ]
  },
  {
    versao: '2.33.76',
    data: '01/02/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando pad, quadro clínico e alergias ao relatório de visitas'
      },
      {
        tipo: 'add',
        texto: 'Adicionando tags sem valor em modelos de relatórios'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nas compras resultantes dos serviços das vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.75',
    data: '31/01/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria na conciliação bancária'
      }
    ]
  },
  {
    versao: '2.33.74',
    data: '30/01/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado possibilidade de pagar multiplas contas'
      },
      {
        tipo: 'bug',
        texto: 'Adicionada prevenção de erros na consulta de dados nos relatórios de status dos pacientes.'
      },
      {
        tipo: 'bug',
        texto: 'Correção nos preços e custos exibidos em relatórios relacionados a agendamentos.'
      }
    ]
  },
  {
    versao: '2.33.73',
    data: '29/01/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado relatório de status dos pacientes na área Principal e também em Cadastros > Relatórios para otimização do controle de atividades.'
      }
    ]
  },
  {
    versao: '2.33.72',
    data: '26/01/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de visualizar a agenda para o profissional web.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a avaliação antropométrica nas visitas.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nas prescrições das visitas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.71',
    data: '25/01/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.70',
    data: '24/01/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de exibir ou não os aditivos nas vendas'
      },
      {
        tipo: 'add',
        texto: 'Adicionado filtro de clientes nas compras geradas a partir de agendamentos'
      },
      {
        tipo: 'add',
        texto: 'Adicionado histórico dos serviços nas compras geradas a partir de agendamentos'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nas compras geradas a partir de agendamentos'
      },
      {
        tipo: 'bug',
        texto: 'Corrigindo bug na busca de pacientes.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.69',
    data: '22/01/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.68',
    data: '20/01/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Revertido ajuste da versão 2.33.67 na exibição de preços de produtos relacionados a preço de convênio.'
      },
      {
        tipo: 'bug',
        texto: 'Correção das quantidades de medicamentos exibidas na lista de produtos de vendas, farmácia, orçamentos.'
      }
    ]
  },
  {
    versao: '2.33.67',
    data: '19/01/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado sinais vitais na visita.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de utilizar item do estoque do paciente na visita.'
      },
      {
        tipo: 'edit',
        texto: 'Ajuste na exibição de preços de produtos. Caso o cliente tenha algum convênio e este convênio não tiver preço cadastrado para um produto, será exibido o preço padrão do produto cadastrado pela empresa, e não R$ 0,00.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.66',
    data: '18/01/2024',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Definido por padrão como não-obrigatórios os campos informativos em modelos de evolução e avaliação profissional.'
      }
    ]
  },
  {
    versao: '2.33.65',
    data: '15/01/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionados relatórios de Pacotes em PDF e Excel.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de PDFs na área financeira relacionados ao custo do profissional.'
      }
    ]
  },
  {
    versao: '2.33.64',
    data: '12/01/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção do PDF de visitas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.63',
    data: '11/01/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.62',
    data: '10/01/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado recurso de clonar visitas'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nas permissões de usuários'
      },
      {
        tipo: 'bug',
        texto: 'Correção no relatório da venda'
      }
    ]
  },
  {
    versao: '2.33.61',
    data: '09/01/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção do total de horas trabalhadas no relatorio de pagamentos por agendamentos'
      },
      {
        tipo: 'bug',
        texto: 'Correção dos itens mostrados no relatorio de vendas e orçamentos'
      },
      {
        tipo: 'bug',
        texto: 'Correção no recurso de glosa.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao salvar tabela do produto na venda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.60',
    data: '05/01/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado recurso de glosa para a versão TISS 4.01.00'
      },
      {
        tipo: 'bug',
        texto: 'Correção da data e hora mostrada no relatorio de pagamentos por agendamentos'
      },
      {
        tipo: 'bug',
        texto: 'Correção da data no relatorio de agendamento'
      },
      {
        tipo: 'bug',
        texto: 'Correção da exibição dos itens do pacote'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.59',
    data: '04/01/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.58',
    data: '03/01/2024',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.57',
    data: '02/01/2024',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando info card em contas a pagar.'
      },
      {
        tipo: 'add',
        texto: 'Adicionando a opção de confirmar a agenda.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado filtro tipo da agenda em compras por agendamentos.'
      },
      {
        tipo: 'edit',
        texto: 'Otimização da fonte nas assinaturas em pdfs de visitas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na exibição das contas a pagar'
      }
    ]
  },
  {
    versao: '2.33.56',
    data: '26/12/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando coluna de dosagem em medicamentos e no estoque de medicamentos.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nos pdfs de prescrição para otimizar as impressões.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao salvar itens de prescrições médicas e de dieta.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no relatório de agendamentos.'
      }
    ]
  },
  {
    versao: '2.33.55',
    data: '22/12/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção das ações em compras.'
      },
      {
        tipo: 'bug',
        texto: 'Correção nas compras geradas a partir dos agendamentos.'
      }
    ]
  },
  {
    versao: '2.33.54',
    data: '21/12/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado o histórico das compras.'
      }
    ]
  },
  {
    versao: '2.33.53',
    data: '20/12/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de criar vendas agrupadas.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nos bancos dos dados bancários.'
      }
    ]
  },
  {
    versao: '2.33.52',
    data: '18/12/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção do relatório de agendamentos por pagador.'
      }
    ]
  },
  {
    versao: '2.33.51',
    data: '15/12/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a recorrência de 1 em 1 hora em prescrição.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.50',
    data: '14/12/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.49',
    data: '13/12/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de filtrar os pagamentos pelo convênio dos pacientes.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a funcionalidade de criar pacotes em serviços.'
      }
    ]
  },
  {
    versao: '2.33.48',
    data: '12/12/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria nos dados bancários.'
      }
    ]
  },
  {
    versao: '2.33.47',
    data: '06/12/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no relatório de contas a pagar detalhadas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao criar compras.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao abrir prescrições médicas e de dieta na exibição dos itens adicionados.'
      }
    ]
  },
  {
    versao: '2.33.46',
    data: '05/12/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção ao atualizar preços de produtos em convênios.'
      }
    ]
  },
  {
    versao: '2.33.45',
    data: '04/12/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no relatório de visitas do paciente.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no nome do arquivo de remessa.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao adicionar ou remover produtos das vendas recorrente.'
      },
      {
        tipo: 'bug',
        texto: 'Correção do relatório de vendas.'
      }
    ]
  },
  {
    versao: '2.33.44',
    data: '01/12/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.43',
    data: '30/11/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de criar múltiplos pagamentos usado o PIX.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.42',
    data: '29/11/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de criar compras a partir da agenda do profissional.'
      },
      {
        tipo: 'bug',
        texto: 'Correção do relatório agendamentos por pagador.'
      }
    ]
  },
  {
    versao: '2.33.41',
    data: '28/11/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados na clonagem de prescrições de dieta e orçamentos/vendas.'
      }
    ]
  },
  {
    versao: '2.33.40',
    data: '27/11/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.39',
    data: '24/11/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.38',
    data: '23/11/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado relatório de rendição.'
      }
    ]
  },
  {
    versao: '2.33.37',
    data: '22/11/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.36',
    data: '21/11/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado relatório de balanço por pacientes nas vendas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado relatório de equipamentos dispensados por pacientes.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no relatório de profissionais.'
      }
    ]
  },
  {
    versao: '2.33.35',
    data: '16/11/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado endereço no pdf da ficha de cadastro de pacientes e profissionais.'
      },
      {
        tipo: 'edit',
        texto: 'Adicionada listagem dos agendamentos aceitos de até 30 dias antes e depois do dia atual para criação de nova visita.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado relatório das remessas.'
      }
    ]
  },
  {
    versao: '2.33.34',
    data: '14/11/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado relatório de pacientes inativos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria do relatório balanço das vendas.'
      }
    ]
  },
  {
    versao: '2.33.33',
    data: '10/11/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de aplicar preços em clientes.'
      }
    ]
  },
  {
    versao: '2.33.32',
    data: '09/11/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando conversão direta para gotas e atualizando o relatório de novos pacientes cadastrados.'
      }
    ]
  },
  {
    versao: '2.33.31',
    data: '08/11/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria ao clonar as vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.30',
    data: '07/11/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.29',
    data: '06/11/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências no relatório de agendamentos por pagador.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências no relatório das vendas.'
      }
    ]
  },
  {
    versao: '2.33.28',
    data: '03/11/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado filtro para mostrar ou não assinatura dos responsáveis por pacientes nos pdfs de visitas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados relacionados à quantidade de itens adicionados e/ou removidos de pacotes devido à sincronização de eventos em vendas associadas a pacotes.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de outras inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.27',
    data: '01/11/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada possibilidade de alterar status de múltiplas compras e pedidos de compra.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nos pagamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências na quantidade de itens ao realizar dispensação.'
      }
    ]
  },
  {
    versao: '2.33.26',
    data: '27/10/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada a área de Dispensações Programadas na Farmácia, podendo adicionar programação no item da venda e com opção de apresentar estas informações no relatório de Venda.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria ao cadastrar dados bancários.'
      }
    ]
  },
  {
    versao: '2.33.25',
    data: '26/10/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria nos dados de terceiros para utilizar como meio de pagamento do profissional.'
      }
    ]
  },
  {
    versao: '2.33.25',
    data: '26/10/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria nos dados de terceiros para utilizar como meio de pagamento do profissional.'
      }
    ]
  },
  {
    versao: '2.33.24',
    data: '25/10/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de cadastrar dados de terceiros para utilizar como meio de pagamento do profissional.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências na quantidade exibida na tela de vendas e dispensação.'
      }
    ]
  },
  {
    versao: '2.33.23',
    data: '24/10/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.22',
    data: '23/10/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a criação de conversão de unidades em Prescrições.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nos custos dos serviços executados por profissionais.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.21',
    data: '20/10/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.20',
    data: '19/10/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.19',
    data: '18/10/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.18',
    data: '17/10/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.17',
    data: '16/10/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionadas novas configurações de instituição: alterar data de check-in/check-out de nova visita, finalizar visita sem adicionar evolução e realizar evolução após encerrar visita.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.16',
    data: '13/10/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção para formatar a quantidade.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção de adicionar ou remover produtos e serviços do Faturamento XML.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a criação de conversão de unidades em Prescrições.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de erro ao exibir custo nos PDFs.'
      }
    ]
  },
  {
    versao: '2.33.15',
    data: '10/10/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de erro ao baixar modelo de documento.'
      }
    ]
  },
  {
    versao: '2.33.14',
    data: '06/10/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando o campo dígito da conta(DV) em dados bancários.'
      },
      {
        tipo: 'add',
        texto: 'Adicionando a tag de custo-profissional em modelo de documentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de erros na fonte pagadora dos cards dos pacientes.'
      }
    ]
  },
  {
    versao: '2.33.13',
    data: '05/10/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhorias na performance de carregamento da seleção de profissionais.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na criação de boletos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências ao exibir convênio do paciente.'
      }
    ]
  },
  {
    versao: '2.33.12',
    data: '04/10/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhorias na performance de carregamento dos cards de pacientes e profissionais.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados no Faturamento XML.'
      }
    ]
  },
  {
    versao: '2.33.11',
    data: '03/10/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria ao desativar a sincronização da agenda do paciente a venda.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias na performance de carregamento do site.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados no Faturamento XML.'
      }
    ]
  },
  {
    versao: '2.33.10',
    data: '02/10/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado os campos Habilitação e Título de eleitor nos cadastros dos Profissionais.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada pdf para Faturamento XML 4.01.00.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados na venda recorrente.'
      }
    ]
  },
  {
    versao: '2.33.09',
    data: '29/09/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado o nome fantasia do pagador ao card paciente.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada a opção de buscar pacientes pelo cliente vinculado.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada nome fantasia do pagador ao fornecedor/cliente.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nos gráficos de relação convênio/pacientes e idade dos pacientes no início.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao criar venda recorrente com a sincronização da agenda do paciente ativa.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao desativar sincronização da agenda do paciente a venda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados na quantidade de itens disponíveis em pacotes associados ao converter orçamento em vendas ou vice-versa.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.08',
    data: '27/09/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada a opção de gerar relatórios de Agendamentos por Pagador.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada a opção de gerar relatórios de novos pacientes cadastrados entre um período.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado o novo motivo "Migração para outra empresa" para inativação do paciente.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na busca de bancos nos dados bancários dos profissionais.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao sincronizar vendas com agenda do paciente.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da ordenação, custos e valores totais dos agendamentos por pagador.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.07',
    data: '25/09/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção ao clonar eventos.'
      }
    ]
  },
  {
    versao: '2.33.06',
    data: '21/09/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada possibilidade de adicionar/modificar carimbo no Módulo do Profissional.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada possibilidade de adicionar/modificar foto do profissional no Módulo do Profissional.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.33.05',
    data: '19/09/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada foto de paciente e profissional na ficha cadastral.'
      },
      {
        tipo: 'add',
        texto: 'Adicionadas duas escalas padrões (a cada 15 dias e a cada mês) para controle de agendamentos.'
      }
    ]
  },
  {
    versao: '2.33.04',
    data: '18/09/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de vincular clientes aos pacientes.'
      }
    ]
  },
  {
    versao: '2.33.03',
    data: '14/09/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de vincular os clientes aos pacientes.'
      }
    ]
  },
  {
    versao: '2.33.03',
    data: '14/09/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado histórico de status de autorização de dispensação para as vendas.'
      }
    ]
  },
  {
    versao: '2.33.02',
    data: '13/09/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria na padronização do formato da hora em Vendas, Orçamentos e Faturamento XML.'
      }
    ]
  },
  {
    versao: '2.33.01',
    data: '12/09/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado mapa para verificar localização no card do paciente e profissional.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na conciliação das contas.'
      }
    ]
  },
  {
    versao: '2.33.00',
    data: '11/09/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de realizar pagamentos bancários no financeiro.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção de realizar conciliação bancária no financeiro.'
      }
    ]
  },
  {
    versao: '2.32.46',
    data: '08/09/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhoria no faturamento XML 4.01.'
      }
    ]
  },
  {
    versao: '2.32.45',
    data: '05/09/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção das datas de aplicação nos relatórios de prescrição semanal.'
      }
    ]
  },
  {
    versao: '2.32.44',
    data: '01/09/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Adicionada possibilidade de gerar Relatório de Vendas (Balanço) de todos clientes.'
      },
      {
        tipo: 'bug',
        texto: 'Correção nos custos dos profissionais ao realizar sincronização de agendamentos às vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de erro reportado ao salvar procedimentos em prescrições de enfermagem.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de erro reportado no Faturamento XML 4.01.00'
      }
    ]
  },
  {
    versao: '2.32.43',
    data: '29/08/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado histórico de movimentação dos itens nas vendas, orçamentos e dispensações.'
      },
      {
        tipo: 'edit',
        texto: 'Adicionadas na inativação de paciente novas opções de Motivos de saída.'
      },
      {
        tipo: 'edit',
        texto: 'Bloqueia a criação do campo "Foto informativa" no Modelo de Evolução caso não seja adicionada uma imagem.'
      },
      {
        tipo: 'edit',
        texto: 'Modificadas configurações para bloquear criar ou editar visitas e eventos retroativos por usuários sem permissão de administrador.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.42',
    data: '28/08/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.41',
    data: '25/08/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.40',
    data: '23/08/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados nas datas dos serviços executados.'
      }
    ]
  },
  {
    versao: '2.32.39',
    data: '22/08/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada no pdf de visitas a assinatura do responsável pelo Paciente, realizada no aplicativo.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados no pdf de visitas.'
      }
    ]
  },
  {
    versao: '2.32.38',
    data: '16/08/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados no XML de faturamento 3.03.03'
      }
    ]
  },
  {
    versao: '2.32.37',
    data: '15/08/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados no relatório de agendamentos de paciente.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados ao cadastrar pacientes.'
      }
    ]
  },
  {
    versao: '2.32.36',
    data: '11/08/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.35',
    data: '10/08/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no relatório e balanço das vendas e orçamentos.'
      }
    ]
  },
  {
    versao: '2.32.34',
    data: '09/08/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Adicionado novo filtro de status Previsto para o relatório de pagamentos por agendamento.'
      },
      {
        tipo: 'edit',
        texto: 'Corrigindo filtragem e cálculos de datas de vendas no relatório de pagamentos por vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências de reatividade de página na filtragem de agendamentos.'
      }
    ]
  },
  {
    versao: '2.32.33',
    data: '08/08/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Adicionados valor, custo total e balanço total nos relatórios de agendamentos.'
      }
    ]
  },
  {
    versao: '2.32.32',
    data: '07/08/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no relatório e balanço das vendas e orçamentos.'
      }
    ]
  },
  {
    versao: '2.32.31',
    data: '03/08/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada opção de gerar Nº guia Prestador.'
      },
      {
        tipo: 'add',
        texto: 'Adicionadas opções de editar e excluir observações da agenda do profissional.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no relatório e balanço das vendas e orçamentos.'
      }
    ]
  },
  {
    versao: '2.32.31',
    data: '03/08/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de gerar Nº guia Prestador.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no relatório e balanço das vendas e orçamentos.'
      }
    ]
  },
  {
    versao: '2.32.30',
    data: '02/08/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionadas configurações para bloquear criar ou editar visitas e eventos retroativos por usuários sem permissão de administrador ou gerente.'
      },
      {
        tipo: 'bug',
        texto: 'Correção dos códigos e preços de itens em pacotes de pacientes com convênio.'
      },
      {
        tipo: 'bug',
        texto: 'Correção das vendas com aditivos no relatório de Vendas faturadas por período.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no relatório e balanço das vendas e orçamentos.'
      }
    ]
  },
  {
    versao: '2.32.29',
    data: '01/08/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no relatório e balanço das vendas e orçamentos.'
      }
    ]
  },
  {
    versao: '2.32.28',
    data: '01/08/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.27',
    data: '31/07/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.26',
    data: '28/07/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada possibilidade de mostrar aplicações nos relatórios de prescrições.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nas datas de execução de serviços e produtos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.25',
    data: '27/07/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado o campo de identificação(ID) do paciente.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a biografia afetiva do profissional no APP e WEB.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.24',
    data: '26/07/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.23',
    data: '21/07/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.22',
    data: '20/07/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada a versão TISS 4.01.00 de internação no XML de faturamento.'
      },
      {
        tipo: 'add',
        texto: 'Adicionados filtros de pacientes e profissionais no Relatório de Agendamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.21',
    data: '18/07/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado relatórios em PDF e Excel de preços de produtos por convênio.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria nos PDF das vendas e orçamentos.'
      }
    ]
  },
  {
    versao: '2.32.20',
    data: '14/07/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado endereço da empresa na barra lateral do CareYes.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada Tabela Simpro e possibilidade de selecionar entre Brasíndice ou Simpro para os produtos disponíveis.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no app web do CareYes.'
      }
    ]
  },
  {
    versao: '2.32.19',
    data: '10/07/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.18',
    data: '07/07/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada configuração da instituição para ocultar ou mostrar alertas ao realizar agendamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados nos alertas de agendamentos.'
      }
    ]
  },
  {
    versao: '2.32.17',
    data: '06/07/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado filtro de especialidades no relatório da folha de ponto.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros ao realizar agendamento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros em pacotes ao excluir múltiplos eventos (agendamentos) associados.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.16',
    data: '05/07/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado alerta ao realizar agendamentos em datas coincidentes.'
      },
      {
        tipo: 'edit',
        texto: 'Ordenação do relatório geral de Vendas por número de venda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados nos relatórios de pagamento por agendamento.'
      }
    ]
  },
  {
    versao: '2.32.15',
    data: '04/07/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhorias no XML.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias no relatório e balanço da venda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.14',
    data: '03/07/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção na exibição de modelos de evolução padrão a partir de permissões.'
      }
    ]
  },
  {
    versao: '2.32.13',
    data: '01/07/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.12',
    data: '30/06/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de informar o custo do serviço do profissional por porcentagem.'
      },
      {
        tipo: 'edit',
        texto: 'Modificada impressão de relatório de agendamentos do paciente de mês para período (data inicial e data final).'
      },
      {
        tipo: 'edit',
        texto: 'Responsividade do card do paciente ao atualizar convênio.'
      },
      {
        tipo: 'edit',
        texto: 'Responsividade do card do profissional ao atualizar especialidades associadas.'
      }
    ]
  },
  {
    versao: '2.32.11',
    data: '28/06/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campo de Descrição em Compras. Este campo será mostrado também em Conta a Pagar.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada informação de valor total por paciente no detalhamento de relatório de Contas a Pagar.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria na distribuição das datas no XML.'
      }
    ]
  },
  {
    versao: '2.32.10',
    data: '26/06/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção selecionar um responsável do paciente em boletos.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção selecionar um cliente em orçamentos.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado o filtro de disponibilidade ao imprimir o relatório do estoque em PDF e EXCEL.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado o filtro de especialidades e versões em EXCEL para os relatórios de Pagamentos por Agendamento.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado o filtro de ordenar relatório de Contas a Pagar por data ou nome do fornecedor/profissional.'
      },
      {
        tipo: 'edit',
        texto: 'Datas de validade (início e término) de pacotes passam a ser de preenchimento obrigatório.'
      }
    ]
  },
  {
    versao: '2.32.9',
    data: '21/06/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada possibilidade de editar data e horário de dispensação/estorno.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado histórico de mudanças na data de dispensação/estorno.'
      },
      {
        tipo: 'edit',
        texto: 'Datas ordenadas de forma decrescente nos históricos de Estoque.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no PDF de notas da visita.'
      }
    ]
  },
  {
    versao: '2.32.8',
    data: '20/06/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.7',
    data: '19/06/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionados impostos da instituição.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado impressão dos impostos no balanço das vendas.'
      }
    ]
  },
  {
    versao: '2.32.6',
    data: '16/06/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novo botão no card do profissional para inserir individualmente custos aos serviços'
      },
      {
        tipo: 'add',
        texto: 'Adicionado novo relatório apresentando os custos que forem adicionados de serviços dos profissionais'
      },
      {
        tipo: 'add',
        texto: 'Adicionado filtro para mostrar/ocultar dados de fornecedores/profissionais ao final do relatório de Contas a Pagar'
      },
      {
        tipo: 'add',
        texto: 'Adicionado nome do serviço no relatório em excel de Agenda do Profissional'
      }

    ]
  },
  {
    versao: '2.32.5',
    data: '15/06/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.4',
    data: '14/06/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado PDF de balanço em vendas.'
      }
    ]
  },
  {
    versao: '2.32.3',
    data: '13/06/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionados a opção de alterar o título do PDF de vendas e orçamentos.'
      }
    ]
  },
  {
    versao: '2.32.2',
    data: '12/06/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionados relatórios para o SNGPC.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado novo relatório detalhado de Contas a Pagar por Profissional.'
      },
      {
        tipo: 'edit',
        texto: 'Ajustes de informações nos relatórios existentes de Contas a Pagar.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de filtragem no relatório de Estoques Completo por Validade.'
      }
    ]
  },
  {
    versao: '2.32.1',
    data: '07/06/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novo PDF de Estoque por Vencimento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.32.0',
    data: '06/06/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionadas informações de Histórico sobre atualizações e movimentações em pacotes.'
      },
      {
        tipo: 'add',
        texto: 'Adicionadas informação do pacote associado aos pdfs de prescrições.'
      },
      {
        tipo: 'add',
        texto: 'Adicionadas informações sobre vencimento de pacotes na área inicial.'
      },
      {
        tipo: 'add',
        texto: 'Adicionadas notificações 10 dias antes do vencimento de pacotes e no dia do vencimento.'
      }
    ]
  },
  {
    versao: '2.31.9',
    data: '05/06/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.31.8',
    data: '02/06/2023',
    conteudo: [
      {
        tipo: 'Add',
        texto: 'Adicionado validações no XML.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.31.7',
    data: '01/06/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de informar multiplas datas dos produtos da venda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da recusa de agendamentos pelo aplicativo.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.31.6',
    data: '31/05/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.31.5',
    data: '30/05/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de informa as datas dos produtos da venda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      },
      {
        tipo: 'edit',
        texto: 'Adicionadas opções de mostrar ou não custo e valor nos relatórios de pagamentos por agendamentos.'
      }
    ]
  },
  {
    versao: '2.31.4',
    data: '29/05/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de informa as datas dos produtos da venda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      },
      {
        tipo: 'bug',
        texto: 'Correção em relatórios da exibição dos custos de visitas iniciadas a partir de agendamentos.'
      },
      {
        tipo: 'edit',
        texto: 'Ajustes ao sincronizar vendas associadas a pacotes.'
      }
    ]
  },
  {
    versao: '2.31.3',
    data: '26/05/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Adicionando coluna de dados bancários do fornecedor/profissional à tabela de Contas a Pagar por Cliente.'
      },
      {
        tipo: 'edit',
        texto: 'Adicionando novo bloqueio para sincronização de duas vendas dentro de um mesmo período.'
      },
      {
        tipo: 'edit',
        texto: 'Ajustes na sincronização de vendas associadas à pacotes.'
      }
    ]
  },
  {
    versao: '2.31.2',
    data: '25/05/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado modelo de contratação ao filtro de profissionais.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado origem em compras.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.31.1',
    data: '24/05/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando a possibilidade de criar múltiplos aditivos nas vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.31.0',
    data: '23/05/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionando pacotes que podem ser associados à vendas, orçamentos e prescrições.'
      },
      {
        tipo: 'bug',
        texto: 'Correção da busca em orçamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao gerar novas prescrições ou novos itens de prescrições.'
      }
    ]
  },
  {
    versao: '2.30.28',
    data: '19/05/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado versões a tabela de domínio dos convênios.'
      }
    ]
  },
  {
    versao: '2.30.27',
    data: '16/05/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção nos XML de internação.'
      },
      {
        tipo: 'bug',
        texto: 'Correção das buscas na área de Vendas e Farmácia.'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao erro reportado: quando uma prescrição apresentar determinada quantidade de itens e, ao clicar, não for possível visualizá-los, alterar ordenação e recarregar página.'
      }
    ]
  },
  {
    versao: '2.30.26',
    data: '15/05/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.25',
    data: '12/05/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.24',
    data: '10/05/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a possibilidade de definir os valores das parcelas em vendas.'
      }
    ]
  },
  {
    versao: '2.30.23',
    data: '09/05/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado relatório no aditivo de orçamento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.22',
    data: '08/05/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.21',
    data: '05/05/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado mudança de preço automática nos produtos e convênios ao atualizar tabela brasíndice.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.20',
    data: '03/05/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.19',
    data: '02/05/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado filtro de status do agendamento no relatório da agenda do paciente.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado notificação para aniversariantes.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.18',
    data: '27/04/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado o autopreenchimento das datas dos serviços realizados nas vendas após utilizar a sincronização com agenda do paciente.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção JTT em Via de Administração ao adicionar itens na prescrição médica.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção de imprimir informações das avaliações antropométrica no PDF de visitas.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no relatório de pagamentos por agendamentos.'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no relatório de pagamentos por vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.17',
    data: '20/04/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.16',
    data: '19/04/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.15',
    data: '18/04/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado o PDF completo para vendas e orçamentos.'
      }
    ]
  },
  {
    versao: '2.30.14',
    data: '13/04/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada opção de mostrar ou não a data de início nos relatórios de visitas dos pacientes.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado novo relatório de pagamento de profissionais por agendamentos.'
      },
      {
        tipo: 'edit',
        texto: 'Adicionadas novas informações de valor e balanço nos relatórios de agendamentos.'
      },
      {
        tipo: 'edit',
        texto: 'Correção da ordenação na tabela de Fornecedores e Clientes.'
      }
    ]
  },
  {
    versao: '2.30.13',
    data: '11/04/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Mostrar prescrições correspondentes ao paciente no Módulo da Família.'
      }
    ]
  },
  {
    versao: '2.30.12',
    data: '10/04/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Mostrar Razão Social e CNPJ da empresa nos relatórios de Faturamento XML.'
      }
    ]
  },
  {
    versao: '2.30.11',
    data: '06/04/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Mostrar valor e balanço no relatório de Agendamento Profissional completo (Excel e PDF).'
      },
      {
        tipo: 'edit',
        texto: 'Ao criar novo Orçamento, a data de orçamento padrão ficará como a data de criação, podendo ser modificada.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de salvamento das configurações de impressão na área de Agendamentos.'
      }
    ]
  },
  {
    versao: '2.30.10',
    data: '05/04/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada a versão TISS 3.03.03 de SP/SADT no XML de faturamento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.9',
    data: '04/04/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada possibilidade de impressão de relatórios na área de estoque de Medicamentos por tipo (Todos os tipos ou Controlados).'
      },
      {
        tipo: 'bug',
        texto: 'Correção ao adicionar ou deletar produtos na área de vendas, ou orçamentos.'
      },
      {
        tipo: 'edit',
        texto: 'Ajuste estético da área inicial, cards e janelas do site.'
      }
    ]
  },
  {
    versao: '2.30.8',
    data: '03/04/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.7',
    data: '31/03/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada a versão TISS 3.03.03 de internação no XML de faturamento.'
      }
    ]
  },
  {
    versao: '2.30.6',
    data: '30/03/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.5',
    data: '29/03/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada possibilidade de ordenar os itens nas tabelas das vendas e orçamentos para serem impressos em PDF na ordem configurada. A ordenação também ficará salva para os próximos acessos.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada possibilidade de converter uma venda em um orçamento na área de Editar Venda.'
      },
      {
        tipo: 'edit',
        texto: 'Ajuste estético na tabela de Cadastros > Medicamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção para evitar adicionar mais do que um mesmo produto à uma mesma prescrição.'
      },
      {
        tipo: 'bug',
        texto: 'Correção para salvar ou editar corretamente prescrições de acordo com o seu tipo: dieta ou médica.'
      }
    ]
  },
  {
    versao: '2.30.4',
    data: '24/03/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.3',
    data: '23/03/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.2',
    data: '22/03/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novos campos aos sinais vitais.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada a avaliação antropométrica.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado novos campos aos sinais vitais no aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada a avaliação antropométrica no aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado alterações visuais no aplicativo.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.1',
    data: '21/03/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada opção de imprimir o relatório de Contas a Pagar e Contas a Receber por categorias de receitas e despesas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada opção de imprimir o relatório de Vendas e Orçamentos em formato paisagem.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada uma Observação ao editar itens de Orçamentos e Vendas que aparecerá no PDF em modo paisagem.'
      },
      {
        tipo: 'add',
        texto: 'Adicionados botões de Novo profissional e Novo fornecedor ao criar nova compra.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada filtragem por mês e ano em Compras e Orçamentos.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada filtragem por status de atendimento no relatório de Pacientes.'
      },
      {
        tipo: 'edit',
        texto: 'Quando a necessidade de permissão de dispensação estiver ativada, quem não for Administrador não visualizará Dispensações não analisadas ou não autorizadas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.30.0',
    data: '16/03/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionada a versão TISS 4.01.00 no XML de faturamento.'
      },
      {
        tipo: 'add',
        texto: 'Adicionada a possibilidade de realizar avaliações de profissionais no módulo da família.'
      },
      {
        tipo: 'add',
        texto: 'Atualização do Módulo da Família, adicionando possibilidade de visualizar: Avaliações antropométricas, Avaliações profissionais, Cartão de Vacinas, Estoque, Evoluções, Exames, Prescrições, Prontuário Afetivo, Senha e Sinais Vitais do paciente (checar permissões nas configurações de usuário e senha).'
      },

      {
        tipo: 'add',
        texto: 'Adicionado status de atendimento no cadastro do paciente.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado campo para seleção do modelo de contratação do profissional.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado botão de configuração para permitir ou não verificação de cada venda pelo admin master antes de realizar dispensações (área de farmácia e venda)'
      },
      {
        tipo: 'bug',
        texto: 'Correção do tamanho das colunas da tabela no pdf de estoque.'
      },
      {
        tipo: 'edit',
        texto: 'Adicionados todos os períodos de aplicação existentes nos pdfs de prescrições.'
      }
    ]
  },
  {
    versao: '2.29.18',
    data: '03/03/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.17',
    data: '02/03/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.16',
    data: '01/03/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.15',
    data: '27/02/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.14',
    data: '24/02/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no PDF fluxo de caixa mensal.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.13',
    data: '20/02/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.12',
    data: '17/02/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Correção do período de uso "Outro" na área de Prescrições'
      },
      {
        tipo: 'edit',
        texto: 'Correção da soma das quantidades no relatório de dispensação por histórico e por tipo.'
      },
      {
        tipo: 'edit',
        texto: 'Correção das informações exibidas no relatório de dispensação por histórico e por data.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.11',
    data: '16/02/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.10',
    data: '15/02/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.10',
    data: '10/02/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.9',
    data: '10/02/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.8',
    data: '08/02/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.7',
    data: '07/02/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.6',
    data: '02/02/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novos relatórios nas áreas de Vendas e Compras.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado despesas no módulo financeiro.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.5',
    data: '27/01/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a possibilidade de personalizar informações de topo e final de página para os relatórios de Orçamentos e Vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.4',
    data: '26/01/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Associar venda à prescrições de enfermagem.'
      },
      {
        tipo: 'edit',
        texto: 'Correção da clonagem de prescrições médicas e de dieta.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.3',
    data: '24/01/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a possibilidade de anexar arquivos a compra.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.2',
    data: '23/01/2023',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Melhorias na guia da venda.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias na sincronização do agendamento a venda.'
      }
    ]
  },
  {
    versao: '2.29.1',
    data: '18/01/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado relatório de aditivo da venda.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias ao inativar medicamentos, serviços, equipamentos, dietas e serviços.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.29.0',
    data: '17/01/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado criação de venda associada a prescrições médicas e de dieta.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado informação de "unidade" nas áreas de venda.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado PDF de dispensação na farmácia.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado PDF de estorno na farmácia.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.28.4',
    data: '12/01/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de imprimir o relatório financeiro do Contas a Receber por Categoria e Convênio.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção de imprimir o relatório financeiro do Contas a Pagar por Categoria.'
      }
    ]
  },
  {
    versao: '2.28.3',
    data: '11/01/2023',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado um botão com a funcionalidade de sincronizar automaticamente a agenda dos pacientes nas vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.28.2',
    data: '06/01/2023',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias nos relatórios das prescrições.'
      }
    ]
  },
  {
    versao: '2.28.1',
    data: '20/12/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no pdf de visitas'
      }
    ]
  },
  {
    versao: '2.28.0',
    data: '19/12/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a funcionalidade de sinais vitais do paciente no APP e WEB'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a funcionalidade de exames do paciente no APP e WEB'
      },
      {
        tipo: 'add',
        texto: 'Adicionado o prontuário afetivo do paciente no APP e WEB'
      },
      {
        tipo: 'add',
        texto: 'Adicionado os modelos NEAD e ABMID como modelos de evolução no APP e WEB.'
      }
    ]
  },
  {
    versao: '2.27.13',
    data: '09/12/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado exibir alertas ao baixar XML de faturamento'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção de salvar texto em informações para impressão no topo e no final do documento na venda e no orçamento'
      }
    ]
  },
  {
    versao: '2.27.12',
    data: '07/12/2022',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Alterado a geração de XML'
      }
    ]
  },
  {
    versao: '2.27.11',
    data: '01/12/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.27.10',
    data: '29/11/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.27.9',
    data: '28/11/2022',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Alterado a listagem dos lotes no Faturamento XML para exibir por mês.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado unidade de medida "colheres" na prescrição de dieta.'
      }
    ]
  },
  {
    versao: '2.27.8',
    data: '25/11/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.27.7',
    data: '21/11/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.27.6',
    data: '17/11/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.27.5',
    data: '11/11/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.27.4',
    data: '09/11/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.27.3',
    data: '07/11/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de selecionar o lote no momento da escolha do produto.'
      },
      {
        tipo: 'edit',
        texto: 'Ao estornar um item na venda ou na farmácia, permite selecionar a opção de excluí-lo automaticamente da venda.'
      },
      {
        tipo: 'edit',
        texto: 'Relatórios de dispensação e estorno na farmácia agora terão a opção de mostrar ou não o preço do item.'
      }
    ]
  },
  {
    versao: '2.27.2',
    data: '31/10/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }

    ]
  },
  {
    versao: '2.27.1',
    data: '28/10/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado guia de internação XML.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de inserir o motivo da recusa no orçamento recusado.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado um card no dashboard com orçamentos recusados.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }

    ]
  },
  {
    versao: '2.27.0',
    data: '26/10/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade de gerar Boletos.'
      }
    ]
  },
  {
    versao: '2.26.2',
    data: '25/10/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }]
  },
  {
    versao: '2.26.1',
    data: '14/10/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de Selecionar e Faturar múltiplas vendas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de mostrar ou não o preço dos itens dispensados na área da farmácia.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias nos relatórios de Prescrição.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.26.0',
    data: '11/10/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de salvar filtro em agenda de pacientes.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado nas configurações de visita a possibilidade de definir um raio de distância.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a possibilidade de confirmar uma administração/procedimento quando for realizada em cada horário previsto na prescrição no Aplicativo e na Web.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado notificação aos profissionais sobre cada horário de administração de medicamento/dieta/procedimento de enfermagem no Aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de iniciar visita em raio de distância determinado no Aplicativo.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.25.0',
    data: '26/09/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade para realizar aplicações de prescrições durante as visitas.'
      },
      {
        tipo: 'edit',
        texto: 'Possibilidade de gerar relatórios de prescrição de enfermagem em um período maior que 7 dias.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado botão de clonagem de prescrição.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.24.2',
    data: '22/09/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.24.1',
    data: '21/09/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.24.0',
    data: '19/09/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de imprimir ficha cadastral de Pacientes e Profissionais.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado funcinalidade de Pedido de Compra.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.23.7',
    data: '08/09/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.23.6',
    data: '05/09/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção filtrar Fornecedores e clientes, e imprimir listagem.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção filtrar serviços e imprimir listagem.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.23.5',
    data: '01/09/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado recurso de Glosa em XML.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de anexar imagens das prescrições.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.23.4',
    data: '25/08/2022',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Ajustes nos relatórios de agendamentos e prescrições.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado ultimas mensagens recebidas nos avisos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.23.3',
    data: '19/08/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.23.2',
    data: '16/08/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado relatório de Orçamentos por período.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de criar venda recorrente.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção que permite o cadastro de Kits contendo Medicamentos, Materiais, Dietas e Equipamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.23.1',
    data: '02/08/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de criar aditivo de venda e orçamento.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado filtros na agenda do profissional.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.23.0',
    data: '28/07/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado área de avaliação de profissionais.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de enviar e assinar documentos com a plataforma de assinatura digital Autentique.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.22.5',
    data: '18/07/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado módulo para utilização do  Sistema Nacional de Gerenciamento de Produtos Controlados – SNGPC.'
      },
      {
        tipo: 'edit',
        texto: 'Ajustes e melhorias nos relatórios de PDF de Visitas e Prescrições Médicas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de ocultar título das evoluções nos relatórios de visitas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.22.4',
    data: '13/07/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.22.3',
    data: '12/07/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado alertas no sistema web para: Mensagens Recebidas, Agendamentos Recusados, Estoque vencidos entre outros.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de fazer uma nova dispensação na Farmácia.'
      },
      {
        tipo: 'edit',
        texto: 'Ajustes e melhorias nos relatórios de PDF de Visitas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado permissão de visualização para a família no Modelos de Evolução.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção que permite definir o título dos relatórios de evolução.'
      }

    ]
  },
  {
    versao: '2.22.2',
    data: '08/07/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.22.1',
    data: '05/07/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado informação de uso de insumos do estoque na área de Notas de Evolução.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado informação de uso de insumos do estoque nos PDFs de Visitas dos pacientes.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de filtrar por especialidade a agenda de um paciente.'
      }

    ]
  },
  {
    versao: '2.22.0',
    data: '04/07/2022',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Modelo de evolução e Serviços agora só aparecem no aplicativo de acordo com a especialidade do profissional.'
      },
      {
        tipo: 'add',
        texto: 'Exibição da Especialidade do Profissional nas Visitas no aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Exibição do Convênio do Paciente no menu Informações no aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Profissional pode alterar a senha de acesso no aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Opção de adicionar Datas de Início e Término nas Prescrições.'
      },
      {
        tipo: 'add',
        texto: 'Exibição de Data de Validade de Prescrições e Estoque no aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Opção de definir o prazo de exibição no aplicativo das Visitas realizadas.'
      },
      {
        tipo: 'add',
        texto: 'Opção de definir quais Especialidades poderão criar novas Prescrições de Dieta, Medicamentos e de Enfermagem.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de imprimir fotos da galeria na evolução do paciente.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }

    ]
  },
  {
    versao: '2.21.5',
    data: '29/06/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção do administrador definir menus de acesso dos usuários.'
      },
      {
        tipo: 'edit',
        texto: 'Adicionado melhorias de aparência nos relatórios PDFs.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }

    ]
  },
  {
    versao: '2.21.4',
    data: '22/06/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado nova opção de visualização de tabelas de medicamentos, materiais e equipamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }

    ]
  },
  {
    versao: '2.21.3',
    data: '15/06/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado nova funcionalidade de cartão de vacina para pacientes e profissionais.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }

    ]
  },
  {
    versao: '2.21.2',
    data: '15/06/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }

    ]
  },
  {
    versao: '2.21.1',
    data: '14/06/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novas tags no modelo de documentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }

    ]
  },
  {
    versao: '2.21.0',
    data: '10/06/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campo de  inserir imagem ao modelo de evolução (de Paciente)'
      },
      {
        tipo: 'edit',
        texto: 'Melhoria no relatório de estoque.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado relatório de estoque no paciente.'
      },
      {
        tipo: 'add',
        texto: 'Visitas realizadas disponíveis na agenda do profissional e paciente.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado visitas realizadas não previstas no relatorio completo da agenda.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado prescrição de dieta no Aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado campo de  inserir imagem ao modelo de evolução no Aplicativo.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }

    ]
  },
  {
    versao: '2.20.1',
    data: '02/06/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.20.0',
    data: '01/06/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado tipo de produto "Dieta"'
      },
      {
        tipo: 'add',
        texto: 'Adicionado prescrição de dieta.'
      }
    ]
  },
  {
    versao: '2.19.9',
    data: '31/05/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de visualizar prescrição médica em lista.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.19.8',
    data: '26/05/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de gerar relatório do lote no faturamento XML.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.19.7',
    data: '25/05/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.19.6',
    data: '24/05/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novo relátorio de visitas no formato PDF e EXCEL.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.19.5',
    data: '23/05/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campo "Observações" na guia do XML.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.19.4',
    data: '19/05/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de importar Nota XML no menu Compras.'
      },
      {
        tipo: 'edit',
        texto: 'Ajustes nos relatórios de visistas.'
      },
      {
        tipo: 'edit',
        texto: 'Ajustes nos relatórios comercial e farmácia.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.19.3',
    data: '10/05/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de selecionar assinatura no relatório de venda.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias nos PDFs da farmácia.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.19.2',
    data: '10/05/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade de upload de arquivos nos profissionais e pacientes.'
      },
      {
        tipo: 'edit',
        texto: 'Melhorias no uso do XML nas vendas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.19.1',
    data: '06/05/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.19.0',
    data: '04/05/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de selecionar agendamento disponível ao iniciar visita pelo profissional no Aplicativo.'
      },
      {
        tipo: 'edit',
        texto: 'Mudança ao iniciar visita e iniciar nota de evolução no Aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de iniciar uma visita pela agenda do profissional que esteja com evento aceito no Aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado obrigatoriedade na seleção de serviço ao iniciar visita e ao selecionar modelo de evolução quando iniciar Nota de Evolução no Aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado notificações de novos avisos no Aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de carimbo na assinatura do profissional no Aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de exibir prescrição de enfermagem completa no Aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de selecionar agendamento disponível ao iniciar visita no Aplicativo.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de selecionar período e opção de relatório completo no relatório da agenda do profissional.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado ícone "check" nos agendamentos que os profissionais compareceram.'
      },
      {
        tipo: 'star',
        texto: 'Novas melhorias de formatação e novas tags no Modelo de Documentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.18.3',
    data: '19/04/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de gerar arquivo XLSX (Excel) do relatório de agendamento do paciente.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado novo nível de permissão de acesso chamado Secretário (a), tendo acesso restrito ao menu Empresa, Comercial e ao Financeiro.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.18.2',
    data: '12/04/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade que permite buscar lote pela identificação no Estoque.'
      },
      {
        tipo: 'edit',
        texto: 'Adaptação para uso de leitor de código de barras na Farmácia.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade que permite gerar código de barras  do lote de produtos (Equipamentos, Materiais e Medicamentos).'
      }
    ]
  },
  {
    versao: '2.18.1',
    data: '07/04/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.18.0',
    data: '29/03/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado ao dashboard o card de visitas em aberto e o card de visitas concluídas nas últimas 48 horas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção de associar paciente no card do profissional.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado no Módulo da Família a opção de visualização da agenda do paciente. Sem qualquer edição.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção que permite definir profissional no cadastro reserva.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado na farmácia a coluna que informa status da venda.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de criar novo procedimento na página inicial da prescrição de enfermagem.'
      }
    ]
  },
  {
    versao: '2.17.11',
    data: '23/03/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção que permite o profissional aceitar ou recusar agendamentos. (Aplicativo)'
      },
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade de enviar mensagem na seção de avisos. (Aplicativo)'
      },
      {
        tipo: 'edit',
        texto: 'Alterado aviso para mensagens na seção de avisos. (Aplicativo)'
      },
      {
        tipo: 'bug',
        texto: 'Correção da data e no campo explicativo da nota de evolução. (Aplicativo)'
      },
      {
        tipo: 'add',
        texto: 'Adiconado "agendamentos recusados" e "últimas mensagens recebidas" no dashboard principal.'
      }
    ]
  },
  {
    versao: '2.17.10',
    data: '22/03/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado relatório por fornecedor e cliente no Contas a pagar e no Contas a receber.'
      }
    ]
  },
  {
    versao: '2.17.9',
    data: '17/03/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.17.8',
    data: '16/03/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opções de gerar relatórios de agendamentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.17.7',
    data: '14/03/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de gerar comissões de vendas para profissionais.'
      }
    ]
  },
  {
    versao: '2.17.6',
    data: '10/03/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.17.5',
    data: '09/03/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado nova opção de impressão do relatório de prescrição de enfermagem.'
      }
    ]
  },
  {
    versao: '2.17.4',
    data: '03/03/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.17.3',
    data: '02/03/2022',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.17.2',
    data: '23/02/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de visualizar farmácia de vendas faturadas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.17.1',
    data: '22/02/2022',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade de gerar recibos de pagamentos e recebimentos.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado tags do financeiro no modelo de documentos.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.17.0',
    data: '15/02/2022',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Novo Módulo Financeiro. Entre em contato agora e adquira o seu!!!'
      }
    ]
  },
  {
    versao: '2.16.1',
    data: '29/12/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.16.0',
    data: '27/12/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade de visualizar pacientes e profissionais em lista.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado ocultação de valores para usuário do tipo assistente.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de exportar relatório da agenda do Profissional no formato .xlsx (Excel).'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.47',
    data: '21/12/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.46',
    data: '20/12/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.45',
    data: '20/12/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade de visualizar prescrições de enfermagem no aplicativo'
      },
      {
        tipo: 'add',
        texto: 'Adicionado data de nascimento ao paciente no aplicativo'
      },
      {
        tipo: 'add',
        texto: 'Adicionado alergia no MENU  de informações do paciente no aplicativo'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados'
      }
    ]
  },
  {
    versao: '2.15.44',
    data: '14/12/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção no layout do PDF de modelo de evolução'
      }
    ]
  },
  {
    versao: '2.15.43',
    data: '13/12/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novo tipo de administração de medicamentos'
      }]
  },
  {
    versao: '2.15.42',
    data: '13/12/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campo de data de inclusão no profissional'
      },
      {
        tipo: 'add',
        texto: 'Adicionado tag "data de inclusão" no modelo de documentos'
      },
      {
        tipo: 'bug',
        texto: 'Correção no layout do PDF de modelo de evolução'
      }
    ]
  },
  {
    versao: '2.15.41',
    data: '09/12/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade de imprimir modelo de evolução'
      }
    ]
  },
  {
    versao: '2.15.40',
    data: '08/12/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.39',
    data: '02/12/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado nova tabela de medicamentos.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de selecionar custo ou valor para aparecer no relatório da agenda do profissional.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.38',
    data: '30/11/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.37',
    data: '22/11/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.36',
    data: '10/11/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.35',
    data: '09/11/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Alteração no formato de visualização dos relatórios.'
      },
      {
        tipo: 'star',
        texto: 'Adicionado novas tags no modelo de documento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.33',
    data: '01/11/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.32',
    data: '29/10/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado a opção de selecionar se aparecer valor e custo no relatório de agenda.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade de inserir acréscimo nas vendas.'
      }
    ]
  },
  {
    versao: '2.15.31',
    data: '26/10/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de relatório simplificado na prescrição de enfermagem.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade de clonar modelo de nota de evolução.'
      },
      {
        tipo: 'star',
        texto: 'Melhoria nos relatórios de prescrição médica e de enfermagem.'
      }
    ]
  },
  {
    versao: '2.15.30',
    data: '20/10/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.29',
    data: '19/10/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Mudança na forma de visualização das visitas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.28',
    data: '11/10/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.27',
    data: '08/10/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Adicionado novos campos "Nível Complexidade" e "Alergia" ao paciente.'
      },
      {
        tipo: 'star',
        texto: 'Adicionado funcionalidade que permite criar contagem de dias dos equipamentos em vendas.'
      },
      {
        tipo: 'star',
        texto: 'Atualização nos relatórios de venda e orçamento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.26',
    data: '01/10/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Adicionado novo formato de visualização da agenda do paciente e do profissional.'
      },
      {
        tipo: 'star',
        texto: 'Adicionado tooltip de visualização da dosagem de medicamentos.'
      },
      {
        tipo: 'star',
        texto: 'Adicionado opção de se necessário no horário da prescrição médica.'
      }
    ]
  },
  {
    versao: '2.15.25',
    data: '28/09/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Atualização no aplicativo: Melhoria na Câmera, Localização e Campos obrigatórios'
      }
    ]
  },
  {
    versao: '2.15.24',
    data: '24/09/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Adicionado a opção que permite marcar campo como obrigatório no modelo de nota de evolução.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.23',
    data: '21/09/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.22',
    data: '17/09/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.21',
    data: '09/09/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.20',
    data: '02/09/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Adicionado opção de ordenar Pacientes e Profissionais em ordem alfabética e de cadastro.'
      },
      {
        tipo: 'star',
        texto: 'Adicionado a opção de remover prescrição médica e de enfermagem.'
      },
      {
        tipo: 'star',
        texto: 'Adicionado botões de acesso às prescrições médicas e de enfermagem a partir do card do paciente.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.19',
    data: '26/08/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Adicionado permissão de acesso aos modelos de documentos para usuário Assistente.'
      },
      {
        tipo: 'star',
        texto: 'Adicionado a opção de selecionar o tipo de mudança no preço do convênio nos menus Serviços, Medicamentos, Materiais e Equipamentos. Possibilitando alterar os preços das vendas em andamento e vendas futuras ou apenas das vendas futuras.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.18',
    data: '24/08/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade de prescrição de enfermagem.'
      }
    ]
  },
  {
    versao: '2.15.17',
    data: '23/08/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Adicionado geolocalização no início da visita do profissional ao paciente.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.16',
    data: '20/08/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.15',
    data: '10/08/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novo nível de permissão de acesso chamado Assistente, tendo acesso restrito ao menu Empresa e ao Financeiro.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado a opção de selecionar o tipo de mudança no preço no convênio. Possibilitando alterar os preços das vendas em andamento e vendas futuras ou apenas das vendas futuras.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado no aplicativo as prescrições médicas do paciente.'
      }
    ]
  },
  {
    versao: '2.15.14',
    data: '04/08/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Criado o botão para retornar Venda Faturada, podendo ser utilizado apenas pelo usuário administrativo.'
      }
    ]
  },
  {
    versao: '2.15.13',
    data: '04/08/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigido assinatura de notas/visitas por profissional.'
      }
    ]
  },
  {
    versao: '2.15.12',
    data: '04/08/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campo custo do serviço na agenda. Com isso será possível adicionar um custo para os serviços na agenda.'
      },
      {
        tipo: 'star',
        texto: 'Atualização no relatório da agenda do profissional, a partir de agora conta com uma coluna de custo, a soma total do valor dos custos e o balanço (a diferença do valor total e o valor total do custos).'
      }
    ]
  },
  {
    versao: '2.15.11',
    data: '30/07/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Adicionado nome e registro na assinatura dos profissionais nos PDFs de visita e notas da visita.'
      }
    ]
  },
  {
    versao: '2.15.10',
    data: '29/07/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Adicionado assinatura dos profissionais nos PDFs de visita e notas da visita.'
      }
    ]
  },
  {
    versao: '2.15.9',
    data: '29/07/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campo MEI ao profissional, e o campo observações em paciente.'
      }
    ]
  },
  {
    versao: '2.15.8',
    data: '27/07/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.7',
    data: '21/07/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado flag de visualização da evolução.'
      }
    ]
  },
  {
    versao: '2.15.6',
    data: '19/07/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campo de chave pix nos dados bancários do profissional.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção "se necessário" nas prescrições de pacientes.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.5',
    data: '06/07/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado função copiar-colar agendamento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.4',
    data: '05/07/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.3',
    data: '24/06/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Correção de inconsistências e erros reportados.'
      }
    ]
  },
  {
    versao: '2.15.2',
    data: '05/06/2021',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Alterado cor de eventos coringa.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido dispensação de produtos vencidos na farmácia.'
      },
      {
        tipo: 'edit',
        texto: 'Alterado relatório do paciente.'
      }
    ]
  },
  {
    versao: '2.15.1',
    data: '05/06/2021',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Alterado relatório de agendamentos'
      }
    ]
  },
  {
    versao: '2.15.0',
    data: '04/06/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Adicionado upload de imagem em modelos de documentos.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido exibição no tooltip das agendas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de mostrar profissionais relacionados ao selecionar um serviço em vendas/orçamentos.'
      }
    ]
  },
  {
    versao: '2.14.8',
    data: '03/06/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campo de seleção de serviço e preço nos agendamentos.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado campo de seleção para agendamentos coringas.'
      }
    ]
  },
  {
    versao: '2.14.7',
    data: '02/06/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campo nº do PIS/PASEP no cadastro de profissionais e campo nome do pai aos perfis.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado campo nome do pai nos cadastros de perfis (profissional, paciente e responsável).'
      }
    ]
  },
  {
    versao: '2.14.6',
    data: '01/06/2021',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Atualizado tabela de medicamentos disponíveis conforme tabela Brasíndice.'
      },
      {
        tipo: 'edit',
        texto: 'Alterado nomenclatura na criação de usuário profissional e gerente.'
      }
    ]
  },
  {
    versao: '2.14.5',
    data: '26/05/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado filtragem de profissionais por campos específicos desejados.'
      },
      {
        tipo: 'edit',
        texto: 'Alterado visualização inicial padrão de agendas para mês.'
      }
    ]
  },
  {
    versao: '2.14.4',
    data: '21/05/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campo de profissional coringa no cadastro/edição de profissionais.'
      },
      {
        tipo: 'edit',
        texto: 'Alterado ordenação na lista de vendas e itens da farmácia.'
      }
    ]
  },
  {
    versao: '2.14.3',
    data: '19/05/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado tooltip/popup de apoio a visualização de eventos nas agendas.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido cenários de erros levantados ao exportar arquivo XML de faturamento.'
      }
    ]
  },
  {
    versao: '2.14.2',
    data: '14/05/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Adicionado testes de export para XML.'
      }
    ]
  },
  {
    versao: '2.14.1',
    data: '14/05/2021',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigido ordenação e filtro de visitas.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido bloqueio de acesso a usuários inativos.'
      }
    ]
  },
  {
    versao: '2.14.0',
    data: '10/05/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado funcionalidade de adição de lotes e guias do módulo XML.'
      },
      {
        tipo: 'edit',
        texto: 'Alterado local de armazenamento da informação de CBOs.'
      }
    ]
  },
  {
    versao: '2.13.1',
    data: '29/04/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado upload de imagem na evolução para profissionais pela plataforma web.'
      },
      {
        tipo: 'edit',
        texto: 'Alterado relatório de faturamento de convênio para balanço.'
      }
    ]
  },
  {
    versao: '2.13.0',
    data: '07/04/2021',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Adicionado módulo de acesso para profissionais pela plataforma web.'
      }
    ]
  },
  {
    versao: '2.12.7',
    data: '05/04/2021',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Alterado filtro de relatório de pacientes e faturamento por convênio.'
      }
    ]
  },
  {
    versao: '2.12.6',
    data: '03/04/2021',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Alterado preenchimento de especialidades de profissionais.'
      }
    ]
  },
  {
    versao: '2.12.5',
    data: '01/04/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campos para preenchimento em faturamento por XML.'
      }
    ]
  },
  {
    versao: '2.12.4',
    data: '25/03/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado nº da venda ao histórico de movimentações de itens do estoque.'
      }
    ]
  },
  {
    versao: '2.12.3',
    data: '24/03/2021',
    conteudo: [
      {
        tipo: 'edit',
        texto: 'Alterado regras de impressão para relatórios.'
      }
    ]
  },
  {
    versao: '2.12.2',
    data: '17/02/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado dado de registro do profissoinal, quando houver, no relatório de visitas/evoluções.'
      }
    ]
  },
  {
    versao: '2.12.1',
    data: '26/01/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campo observações na edição de um evento da agenda de pacientes e profissionais.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado opção de exclusão de evento em massa a partir de um profissional ou paciente associado.'
      }
    ]
  },
  {
    versao: '2.12.0',
    data: '11/01/2021',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado módulo de visualização das evolução pelos familiares (responsáveis).'
      }
    ]
  },
  {
    versao: '2.11.2',
    data: '26/11/2020',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado campos sobre o PAD no cadastro, edição e inativação do paciente.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado relatório de balanço.'
      }
    ]
  },
  {
    versao: '2.11.1',
    data: '05/11/2020',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado total de serviços executados a serem pagos.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido relatório de pagamento quando não houver visitas a serem pagas.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado informações do lote de materiais/médicamentos/equipamentos no ato do orçamento.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido exibição de produtos vencidos ou com quantidade indisponível na tela de estoque.'
      }
    ]
  },
  {
    versao: '2.11.0',
    data: '01/09/2020',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado novas informações sobre o convênio como endereço e responsáveis.'
      }
    ]
  },
  {
    versao: '2.10.1',
    data: '17/08/2020',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado opção de relatório simples e completo para pacientes.'
      },
      {
        tipo: 'edit',
        texto: 'Alterado o relatório de profissioansi para exibir os pacientes relacionados ao mesmo.'
      }
    ]
  },
  {
    versao: '2.10.0',
    data: '31/07/2020',
    conteudo: [
      {
        tipo: 'del',
        texto: 'Removido rota de atualização das informações de venda.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado segundo campo de informações nos pdfs relacionados a venda.'
      }
    ]
  },
  {
    versao: '2.9.0',
    data: '25/07/2020',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado fotos ao relatório de evolução dos pacientes.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado campo "Via de Administração" nas prescrições.'
      }
    ]
  },
  {
    versao: '2.8.2',
    data: '17/07/2020',
    conteudo: [
      {
        tipo: 'del',
        texto: 'Omitido opção de alterar senha para o usuário "Gerente"'
      },
      {
        tipo: 'add',
        texto: 'Adicionado nova etapa de verificação de permissão no sistema'
      }
    ]
  },
  {
    versao: '2.8.1',
    data: '15/07/2020',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigido ordenação por data e hora no relatório de notas de evolução.'
      }

    ]
  },
  {
    versao: '2.8.0',
    data: '14/07/2020',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado edição e exclusão de notas de evolução.'
      },
      {
        tipo: 'add',
        texto: 'Adicionado permissão de usuário "Gerente" para profissionais.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido um bug nas colunas do relatório de pacientes.'
      },
      {
        tipo: 'del',
        texto: 'Remoção de campos de valor total R$ 0,00 nos relatórios de orçamentos/vendas.'
      }

    ]
  },
  {
    versao: '2.7.1',
    data: '12/06/2020',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigido atualização de preços nos convênios.'
      }
    ]
  },
  {
    versao: '2.7.0',
    data: '20/05/2020',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionado relatório de prescrição semanal.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido um bug na impressão de relatório de pagamentos.'
      }
    ]
  },
  {
    versao: '2.6.12',
    data: '17/03/2020',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigido bug na impressão de modelos de documentos.'
      }
    ]
  },
  {
    versao: '2.6.11',
    data: '13/03/2020',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Valor total em estoque adicionado nos relatórios de estoque.'
      }
    ]
  },
  {
    versao: '2.6.10',
    data: '11/03/2020',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Resolvido um bug de incompatibilidade de datas com safari.'
      }
    ]
  },
  {
    versao: '2.6.9',
    data: '11/03/2020',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Relatório de dispensação da venda adicionado à farmácia.'
      },
      {
        tipo: 'add',
        texto: 'Modelo de relatório completo de profissionais adicionado aos relatórios.'
      },
      {
        tipo: 'bug',
        texto: 'Relatório de pacientes não mostra mais profissionais desativados associados ao profissional.'

      }

    ]
  },
  {
    versao: '2.6.8',
    data: '04/03/2020',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigido um bug na exibição de títulos e subtítulos na timeline de evolução e no pop-up de nova evolução.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido disposição e exibição de conteúdo no PDF de notas de visitas. '

      },

      {
        tipo: 'bug',
        texto: 'Corrigido a atualização de novas evoluções na timeline de evoluções do paciente.'
      }
    ]
  },
  {
    versao: '2.6.7',
    data: '19/02/2020',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Corrigido um bug nos modelos de relatório.'
      },
      {
        tipo: 'star',
        texto: 'Adicionado novas restrições na dispensa de itens pela farmácia.'
      }
    ]


  },

  {
    versao: '2.6.6',
    data: '24/01/2020',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Diversas melhorias na visualização de dados e relatórios.'
      },
      {
        tipo: 'star',
        texto: 'Possibilidade de ordenar históricos de movimentação por data.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido um bug que mostrava botões de dispensação na tela de orcamentos.'
      }
    ]
  },
  {
    versao: '2.6.5',
    data: '22/01/2020',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Otimização no relatório de pagamentos.'
      },
      {
        tipo: 'star',
        texto: 'Otimização na visualização de notas de evolução.'
      },
      {
        tipo: 'bug',
        texto: 'Corrigido um bug que ocultava eventos iniciados e finalizados em semanas diferentes.'
      }
    ]
  },
  {
    versao: '2.6.4',
    data: '13/01/2020',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Otimização no relatório de pagamentos.'
      }
    ]
  },
  {
    versao: '2.6.3',
    data: '13/01/2020',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Atualização no pdf relatório de pagamentos.'
      }
    ]
  },
  {
    versao: '2.6.2',
    data: '13/01/2020',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Barra de identificação no ambiente de testes.'
      },
      {
        tipo: 'star',
        texto: 'Atualização no pdf de dispensação.'
      }
    ]
  },
  {
    versao: '2.6.1',
    data: '08/01/2020',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Várias pequenas melhorias, otimizações e correções de bugs.'
      }
    ]
  },
  {
    versao: '2.6.0',
    data: '11/12/2019',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Novo relatório de estoque, agrupando por produto e lotes.'
      },
      {
        tipo: 'star',
        texto: 'Melhorias de performance e estabilidade.'
      }
    ]
  },
  {
    versao: '2.5.5',
    data: '05/12/2019',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Várias pequenas melhorias, otimizações e correções de bugs.'
      }
    ]
  },
  {
    versao: '2.5.4',
    data: '05/12/2019',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Pequena modificação no relatório de faturamento por convênio.'
      }
    ]
  },
  {
    versao: '2.5.3',
    data: '05/12/2019',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Pequenas modificações nos relatórios de vendas e faturamento.'
      }
    ]
  },
  {
    versao: '2.5.2',
    data: '04/12/2019',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Pequenas modificações no módulo de relatórios.'
      }
    ]
  },
  {
    versao: '2.5.1',
    data: '03/12/2019',
    conteudo: [
      {
        tipo: 'bug',
        texto: 'Várias pequenas melhorias, otimizações e correções de bugs.'
      }
    ]
  },
  {
    versao: '2.5.0',
    data: '27/11/2019',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Desativar venda com distribuições.'
      },
      {
        tipo: 'star',
        texto: 'Estorno automático de equipamento ao faturar venda.'
      },
      {
        tipo: 'star',
        texto: 'Várias pequenas melhorias, otimizações e correções de bugs.'
      }
    ]
  },
  {
    versao: '2.3.5',
    data: '19/11/2019',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Opções de dispensação/estorno automatico na venda.'
      },
      {
        tipo: 'star',
        texto: 'Prescrições adicionadas.'
      },
      {
        tipo: 'star',
        texto: 'Várias pequenas melhorias, otimizações e correções de bugs.'
      }
    ]
  },
  {
    versao: '2.3.0',
    data: '28/10/2019',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Melhoria no relatório de pagamento de profissionais.'
      },
      {
        tipo: 'star',
        texto: 'Melhoria no relatório de faturamento.'
      },
      {
        tipo: 'star',
        texto: 'Várias pequenas melhorias, otimizações e correções de bugs.'
      }
    ]
  },
  {
    versao: '2.2.3',
    data: '17/10/2019',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Opção de inserir o número da venda no cabeço do documento.'
      },
      {
        tipo: 'star',
        texto: 'Correção de bugs e pequenas melhorias.'
      }
    ]
  },
  {
    versao: '2.2.0',
    data: '08/10/2019',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Nova forma de criar modelo de documentos.'
      },
      {
        tipo: 'star',
        texto: 'Correção de bugs e pequenas melhorias.'
      }
    ]
  },
  {
    versao: '2.1.1',
    data: '07/10/2019',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionamos a possibilidade dizer se um produto é ou não dispensável.'
      },
      {
        tipo: 'add',
        texto: 'Relatório de faturamento agrupado por tipo de produto também no histórico.'
      },
      {
        tipo: 'star',
        texto: 'Correção de bugs e pequenas melhorias.'
      }
    ]
  },
  {
    versao: '2.1.0',
    data: '04/10/2019',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Adicionamos a possibilidade de atribuir um funcionário a um serviço durante uma venda.'
      },
      {
        tipo: 'add',
        texto: 'Relatório de pagamento de acordo com as atribuições de um funcionário a um serviço.'
      },
      {
        tipo: 'add',
        texto: 'Adicionar a opção de informar o período de um orçamento ou venda.'
      },
      {
        tipo: 'add',
        texto: 'Relatório faturamento apenas de vendas feitas para particular.'
      },
      {
        tipo: 'add',
        texto: 'Relatório de faturamento agrupado por tipo de produto.'
      },
      {
        tipo: 'star',
        texto: 'Correção de bugs e pequenas melhorias.'
      }
    ]
  },
  {
    versao: '2.0.3',
    data: '03/10/2019',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Novo relatório de dispensação agrupando por tipo de produto.'
      }
    ]
  },
  {
    versao: '2.0.2',
    data: '02/10/2019',
    conteudo: [
      {
        tipo: 'add',
        texto: 'Agora é possível fazer upload de fotos direto da galeria.'
      },
      {
        tipo: 'bug',
        texto: 'Correção de pequenos bugs.'
      },
      {
        tipo: 'bug',
        texto: 'Correção em ocultar meses anteriores no Orçamento.'
      },
      {
        tipo: 'bug',
        texto: 'Correção no relatório de visitas.'
      },
      {
        tipo: 'bug',
        texto: 'Correção em faturar venda.'
      },
      {
        tipo: 'bug',
        texto: 'Correção em alterar senha do profissional.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na data do servidor com a data do usuário.'
      },
      {
        tipo: 'bug',
        texto: 'Correção na impressão de pdfs quando o nome possui ponto.'
      }
    ]
  },
  {
    versao: '2.0.0',
    data: '24/07/2019',
    conteudo: [
      {
        tipo: 'star',
        texto: 'Lançamento da nova versão do CareYes!'
      }
    ]
  }
];

export const items = versoes;
export const versao = versoes[0].versao;
